// https://scotch.io/tutorials/simple-language-translation-in-angular-2-part-2

// lang-de.ts

// 'hello world': 'hello world',
// 'hello greet': 'Hello, %0 %1!',
// 'well done': 'Well done %0',
// 'good bye': 'bye bye',

export const LANG_DE_NAME = "de";

export const LANG_DE_TRANS = {
  LblWeekdays: {
    shorthand: ["So", "Mo", "Di", "Mi", "Do", "Fr", "Sa"],
    longhand: [
      "Sonntag",
      "Montag",
      "Dienstag",
      "Mittwoch",
      "Donnerstag",
      "Freitag",
      "Samstag"
    ]
  },
  LblMonths: {
    shorthand: [
      "Jan",
      "Feb",
      "März ",
      "Apr",
      "Mai",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Okt",
      "Nov",
      "Dez"
    ],
    longhand: [
      "Januar",
      "Februar",
      "März",
      "April",
      "Mai",
      "Juni",
      "Juli",
      "August",
      "September",
      "Oktober",
      "November",
      "Dezember"
    ]
  },

  LblButtonText: {
    Heute: "Heute",
    Monat: "Monat",
    Woche: "Woche",
    Tag: "Tag",
    Liste: "Liste"
  },

  // Common Name
  LblActivityLog: "Aktivitätsprotokoll",
  LblEdit: "Bearbeiten",
  LblDelete: "Löschen",
  LblRemove: "Entfernen",
  LblActiveInactive: "Aktiv/Inaktiv",
  LblActive: "Aktiv",
  LblInactive: "Deaktivieren",
  LblInactiveReason: "Inaktiver Grund",
  LblAddNew: "Neu hinzufügen",
  LblAdd: "Hinzufügen",
  LblUpdate: "Aktualisieren",
  LblSave: "Speichern",
  LblCancel: "Abbrechen",
  LblReset: "Zurücksetzen",
  LblSelect: "Auswählen",
  LblSuccess: "Glückwunsch",
  LblWarning: "Warnung",
  LblList: "Liste",
  LblAssign: "Zuweisen",
  LblHome: "Home",
  LblYes: "Ja",
  LblOK: "Ok",
  LblNo: "Nein",
  LblBack: "Zurück",
  LblReason: "Grund",
  LblRecordSavedSuccess: "Eintrag erfolgreich gespeichert",
  LblRecordDeleteSuccess: "Eintrag erfolgreich gelöscht",
  LblResetPasswordSuccess: "Passwort erfolgreich zurückgesetzt",
  LblConfirm: "Bestätigen",
  LblBlockUnblockConfirm: "Möchten Sie %0 wirklich %1?",
  LblRecordDeleteConfirmation: "Möchten Sie %0 wirklich entfernen?",
  LblRecordMultiplDeleteConfirmation:
    "Möchten Sie die ausgewählten %0 wirklich entfernen?",
  LblConfirmMessage: "Sind Sie sicher?",
  LblResetPassword: "Passwort zurücksetzen",
  LblResetPasswordConfirmation:
    "Möchten Sie Ihr Passwort wirklich zurücksetzen?",
  LblGeoLocationError: "Bitte geben Sie den richtigen Standort ein",
  LblPersonDeleteCheck: "Dauerhaft entfernen",

  LblRejection: "Ablehnung",
  LblrejectionReasonMsg:
    "Bitte begründen Sie die Ablehnung ausgewählter Buchungsanfragen",
  LblApproveConfirmationMsg:
    "Möchten Sie wirklich alle ausgewählten Buchungsanfragen genehmigen?",
  LblBookingCancelSuccess: "Buchungen erfolgreich storniert",
  LblBookingApprovedSuccessMsg:
    "Ausgewählte Buchungsanfragen erfolgreich genehmigt",
  LblBookingRejectedSuccessMsg:
    "Ausgewählte Buchungsanfrage erfolgreich abgelehnt",
  LblBookingAbortSuccess: "Buchung erfolgreich abgebrochen",
  LblBookingRevokeSuccess: "Buchung erfolgreich widerrufen",
  LblContactPersonRemoveSuccess: "Ansprechpartner erfolgreich entfernt",
  LblContactPersonAddedSuccess: "Ansprechpartner erfolgreich hinzugefügt",
  LblNoRecords: "Kein Eintrag verfügbar",
  LblAffectedBookingList: "Liste der betroffenen Buchungen",
  LblSubscriptionEndDateError:
    "Bitte geben Sie das Enddatum des Abonnements ein",
  LblIsSpecialPeriodAllow:
    "Möchten Sie die Sonderperiodenkosten anwenden? Falls zutreffend",
  LblContractSlotisnotdefined:
    "Für das unten stehende Zeitfenster ist kein Vertragstyp definiert",
  LblUnscubscribeSuccess: "Erfolgreich abgemeldet",
  LblModifiedBy: "Geändert von",
  LblModifiedDate: "Änderungsdatum",
  LblContractTypeGroupAvailableForSubscription:
    "Keine Vertragstypengruppe verfügbar, um neue %0 hinzuzufügen.",

  LblRemoveContactPersonConfirm:
    "Sind Sie sicher, dass Sie den Ansprechpartner entfernen wollen?",
  LblBookingApproveRejectSuccess: "%0 %1 erfolgreich",
  LblRecordAddedSuccess: "%0 erfolgreich hinzugefügt.",
  LblRecordUpdatedSuccess: "%0 erfolgreich aktualisiert.",
  LblRecordRemovedSuccess: "%0 erfolgreich entfernt",
  LblRecordActiveInActiveSuccess: "%0 %1 erfolgreich.",
  LblinvoiceResendSuccess: "%0 erfolgreich erneut gesendet",
  LblRecordBlokUnBlockSuccess: "%0 %1 erfolgreich.",
  LblEditPage: "%0 bearbeiten",
  LblAddPage: "%0 hinzufügen",
  LblListPage: "Liste %0",
  LblKilometers: "Kilometer",
  LblKM: "Km",
  LblDeletePersonNote: "Ausstehende Rechnungen für diese Person werden nicht gesendet",  
  LblFileNotFound:"Die Datei existiert nicht, wenden Sie sich an den Helpdesk",

  //'LblRecordUnBlockedSuccess':'%0 unBlocked successfully',
  //MobileApp Configuration
  LblMobileAppConfiguration: "Konfiguration Mobiltelefon-App",
  LblEnableNewBooking: "Neue Buchung aktivieren",
  LblEnableBookingCalender: "Buchungskalender aktivieren",
  LblEnableSubscription: "Abonnement aktivieren",
  LblEnableUpdateProfile: "«Profil aktualisieren» aktivieren",
  LblEnableNotification: "Benachrichtigung aktivieren",
  LblEnableChangeBooking: "«Buchung ändern» aktivieren",
  LblEnableAddExpenseMenu: "Menü für Kostenangabe aktivieren",

  //Instance Page
  LblCarwiseEnable: "Carwise aktiviert",
  LblAdminDependencyValidationOnDelete:
    "Der ausgewählte Admin kann nicht gelöscht werden, da er mit einer anderen Einheit verknüpft ist.",
  LblWegoAdminDependencyValidation:
    "WeGo-Admin kann nicht gelöscht werden, da er mit einer anderen Einheit verknüpft ist.",
  LblAdminDependencyValidation:
    "Die Adminrolle kann nicht entfernt werden, da sie einer anderen Einheit zugeordnet ist.",
  LblCarwiseConfiguration: "Carwise-Konfiguration",
  LblAdminDependencyAlert: "Abhängigkeitsalarm Admin",
  LblCarwiseConnectionUrl: "Verbindungs-URL",
  LblCarwiseConnectionUsername: "Verbindungsbenutzername",
  LblCarwiseConnectionPassword: "Verbindungspasswort",
  LblCarwiseAutoDeleteFrequencyInDays: "Frequenz automatisches Löschen (in Tagen)",
  LblDamageImageExtentions: "Beschädigte Bilderweiterungen",
  LblInstance: "Instanz",
  LblInstanceName: "Instanzname",
  LblInstanceType: "Instanztyp",
  LblDescription: "Beschreibung",
  LblCurrencySymbol: "Währungszeichen",
  LblPreferredLanguage: "Sprache",
  LblTimeZone: "Zeitzone",
  LblCurrencyAbbreviation: "Währungskürzel",
  LblInstanceDeleteValidation:
    "Instanz kann nicht gelöscht werden wegen Verknüpfung mit anderer Einheit",
  LblIsBookingApprovalReq: "Buchungsgenehmigung erforderlich",
  LblInstanceConfiguration: "Instanzkonfiguration",
  LblBookingAlertTime: "Zeit Buchungsbenachrichtigung",
  LblBookingCancelTime: "Zeit Buchungsstorno",
  LblBookingTemporaryTime: "Vorläufige Buchungszeit",
  LblVtsRequestTimeout: "Zeitüberschreitung VTS-Anfrage",
  LblVtsTripLogTimeout: "Zeitüberschreitung VTS-Triplog",
  LblEmailConfiguration: "E-Mail-Konfiguration (SMTP)",
  LblInSeconds: "In Sekunden",
  LblFromEmail: "Aus E-Mail",
  LblHost: "Host",
  LblPort: "Port",
  LblEnableSsl: "SSL aktivieren",
  LblSmtpEmail: "SMTP-E-Mail",
  LblBookingCancelTimeMessage:
    "Zeit (in Sekunden), nach welcher eine Buchung nicht mehr storniert werden kann",
  LblBookingTemporaryTimeMessage:
    "Zeit der vorläufigen Buchung. Wenn der Benutzer ein Fahrzeug für die Buchung ausgewählt, die Buchung aber noch nicht bestätigt hat.",
  LblVtSRequestTimeoutMessage:
    "Zeitüberschreitung für Verriegelungs-/Entriegelungsbefehl in Mobiltelefon-App.",
  LblVtsTriplogTimeoutMessage:
    "Dauer der Zeitüberschreitung für die Berechnung der Fahrt nach Ausführung von Verriegelungsbefehl.",
  LblContractTypeDeleteValidation:
    "Vertragstypengruppe kann nicht gelöscht werden wegen Verknüpfung mit anderer Einheit",
  LblSelectFuelType: "Kraftstoffart auswählen",
  LblSelectPricingCatagory: "Preisklasse auswählen",
  LblSelectBodyStyle: "Karosserietyp auswählen",
  LblSelectVehicleClass: "Fahrzeugklasse auswählen",
  LblIsImportPersonAllow: "Import von Person zulassen",
  LblValidateLicenseA2SP: "A2SP Führerschein validieren",
  LblValidateLicense24IDCheck: "24ID Führerschein validieren",
  LblValidateLicenseForAllBookings: "Führerschein erneut validieren für aller Buchungen",

  LblGeofenceLocation: "Standort Geofence",
  LblRadius: "Radius",
  LblEmailRecepients: "E-Mail-Empfänger",
  LblRecepients: "Empfänger",
  LblEmailAddresses: "E-Mail-Adressen",
  LblMap: "Karte",

  // AFAS/Azure Config
  LblImportConfiguration: "Importkonfiguration",
  LblImportConnectionType: "Connection Type",
  LblAfas: "AFAS",
  LblAzure: "Azure",
  LblAzureTenantId: "Azure Tenant ID",
  LblAzureClientId: "Azure Client ID",
  LblAzureClientSecret: "Azure Client Secret",
  LblAfasClientId: "AFAS Client ID",
  LblAfasConnectorName: "AFAS Connector Name",
  LblAfasConnectionType: "AFAS Connection Type",
  LblAfasTest: "Test",
  LblAfasAccept: "Acceptation",
  LblAfasProduction: "Production",
  LblAfasToken: "AFAS-Token",
  LblAfasClientIdError: "Bitte geben Sie AFAS Client ID ein",
  LblAfasConnectorNameError: "Bitte geben Sie AFAS Client ID ein",
  LblAfasConnectionTypeError: "Bitte geben Sie AFAS Connection Type ein",
  LblAfasTokenError: "Bitte geben Sie AFAS-Token ein",
  LblAzureTenantIdError: "Bitte geben Sie Azure Tenant ID ein",
  LblAzureClientIdError: "Bitte geben Sie Azure Client ID ein",
  LblAzureClientSecretError: "Bitte geben Sie Azure Client Secret ein",

  // SSO Config
  LblSsoConfiguration: "SSO Configuration",
  LblDefaultSsoSharedVehicleGroup: "Default Shared Vehicle Group",
  LblDefaultSsoOrganization: "Default Organization",
  LblDefaultSsoSubscription: "Default Subscription",

  // Dropoff Message
  LblDropoffMessageConfiguration: "Dropoff Message Configuration",
  LblDropoffMessageExternalUrl: "External Url",
  LblDropoffMessageApiKey: "Api Key",
  LblDropoffMessageActive: "Active",

  //Instance Page
  LblValidate: "Validieren",

  LblBookingCalanderSettings: "Einstellungen Buchungskalender",
  LblShowDriverInfo: "Fahrerinformationen in Buchungskalender anzeigen",
  LblOrganizationAdmin: "Admin Organisation",
  LblDriverInfoToShow: "Anzugebende Fahrerinformationen",
  //Person Page
  LblEnableLogin: "Anmeldung aktivieren",
  LblEnableErrorEscalation: "Fehlereskalation aktivieren",
  LblErrorEscalationMinutes: "Fehlereskalation Minuten",
  LblDuplicateErrorEscalation:
    "Doppelte Fehlereskalationskonfiguration gefunden",
  LblUserName: "Benutzername",
  LblFirstName: "Vorname",
  LblLastName: "Nachname",
  LblEmail: "E-Mail",
  LblMobileNumber: "Mobiltelefonnummer",
  LblPhoneNumber: "Telefonnummer",
  LblHomeAddress: "Heimatadresse",
  LblWorkAddress: "Arbeitsadresse",
  LblHouseNo: "Hausnr.",
  LblHouseExtention: "Hausanbau",
  LblStreetName: "Strassenname",
  LblCity: "Ort",
  LblZipCode: "Postleitzahl",
  LblPassword: "Passwort",
  LblConfirmPassword: "Passwort bestätigen",
  LblMiddleName: "Zweiter Vorname",
  LblMandateId: "Mandats-ID",
  LblMandateSignatureDate: "Unterschriftsdatum Mandat",
  LblIsAmmandment: "Ist Amendement",
  LblRemovePersonDetails: "Personendetails entfernen",

  //Company Page
  LblCompany: "Unternehmen",
  LblCompanyName: "Unternehmensname",
  LblContactPerson: "Ansprechpartner",
  LblCompanyAdmin: "Unternehmensadmin",
  LblCompanyAddress: "Unternehmensadresse",
  LblInternalOrganization: "Interne Organisation",
  LblNoOfVegicles: "Anzahl Fahrzeuge",
  LblNoOfSharedVehicleGroups: "Anzahl Carsharing-Gruppen",
  LblGeoLocation: "Standort",
  LblSelectGeoLocation: "Standort auswählen",
  LblPerson: "Person",
  LblRole: "Rollen",
  LblDateOfBirth: "Geburtsdatum",
  LblDriverLicenceNumber: "Führerscheinnummer",
  LblApkExiprationSetting: "Benachrichtigungseinstellungen periodische Wartung",
  LblApkTimeInterval: "Zeitintervall für Benachrichtigungen",
  LblEmailNotification: "E-Mail-Benachrichtigung",
  LblNotificationFrequency: "Benachrichtigungsfrequenz",
  lblThresholdFrequency: "Grenzperiodenfrequenz",
  lblThresholdTimeInterval: "Zeitintervall für Grenzperiode",
  LblIsEmailEnabled: "Benachrichtigungs-E-Mail",
  lblThreshold: "Grenzperiode",
  LblFrequency: "Frequenz",
  LblDay: "Tag",
  LblWeek: "Woche",
  LblMonth: "Monat",

  lblPerBooking: "Pro Buchung",
  LblPersons: "Personen",
  LblPersonOverview: "Personenübersicht",
  LblCompanies: "Unternehmen",
  //Vehicle Page
  LblVehicle: "Fahrzeug",
  LblVtsVehicle: "VTS-Fahrzeug",
  LblFleetId: "Flotten-ID",
  LblContractId: "Vertrags-ID",
  LblVIN: "FIN",
  LblLicenceTag: "Autokennzeichen",
  LblLicence: "Führerschein",
  LblMobile: "Mobiltelefon",
  LblVehicleOwner: "Fahrzeugbesitzer",
  LblLocationDataExchange: "Datenaustausch Standort",
  LblBrand: "Marke",
  LblType: "Typ",
  LblColor: "Farbe",
  LblVehicleClass: "Fahrzeugklasse",
  LblPricingCategory: "Preiskategorie",
  LblBodyStyle: "Karosserietyp",
  LblAvailable: "Verfügbar",
  LblUnAvailable: "Nicht verfügbar",
  LblAvailableFrom: "Verfügbar ab",
  LblAvailableTo: "Verfügbar bis",
  LblFuelType: "Kraftstoffart",
  LblMinBookingTimeBefore: "Mindeste verfügbare Zeit vor Buchung (Minuten)",
  LblMinBookingTimeAfter: "Mindeste verfügbare Zeit nach Buchung (Minuten)",
  LblTowbar: "Anhängerkupplung",
  LblAirco: "Klimaanlage",
  LblVehicleAttributes: "Fahrzeugattribute",
  LblBlockUnBlock: "Blockieren/Freigeben",
  LblRemoveLicense: "Führerschein entfernen",
  LblRemoveLicenseBirthDate: "Führerschein und Geburtsdatum entfernen",
  LblLicenseBirthDate: "Führerschein und Geburtsdatum",
  LblBlock: "Blockieren",
  LblUnblock: "Freigeben",
  LblAvailableUnAvailable: "Verfügbar/Nicht verfügbar",
  LblVehicles: "Fahrzeuge",
  LblBookingsOverview: "Buchungsübersicht",
  LblApkExpirationDateCet: "Ablaufdatum periodische Wartung",
  LblEnabled: "Aktiviert",
  LblDisabled: "Deaktiviert",
  LblIntialOdometerValue: "Ursprünglicher Kilometerstand",
  LblFuelCardPinCode: "Pincode Tankkarte",

  LblFuel: "Kraftstoffart",
  LblVINnumber: "Fahrgestellnummer",
  LblVehicletype: "Fahrzeugtyp",
  LblDoors: "Anzahl Türen",
  LblWeight: "Fahrzeuggewicht",
  LblTrunkSpace: "Kofferraum",
  LblGears: "Anzahl Gänge",
  LblEngineHorsepower: "Motorleistung (PS)",
  LblFuelConsumption: "Krafftstoffverbrauch",
  LblSeats: "Anzahl der Sitze",
  LblDimensions: "Fahrzeugmaße",
  LblTransmissionType: "Getriebeart",
  LblTransmissionUnknown: "Unbekannt",
  LblManualTransmission: "Schaltgetriebe",
  LblAutomaticTransmission: "Automatik",

  LblVehicleDetails: "Fahrzeugdaten",
  LblSelectVehicletype: "Fahrzeugtyp auswählen",
  LblWrongVinNumber: "Falsche Fahrgestellnummer",

  //WEGO2DEV-325(Settings for Dashboard statuses)
  LblVehicleOnSameLocationTime: "Fahrzeug am selben Standort seit mehr als",
  LblNoBookingIn: "Fahrzeug nicht gebucht in mehr als",
  lblHour: "Stunde",
  //'lblInterval':'HOUR/DAY/WEEK/MONTH',
  lblHourDayWeekMonth: "Stunde/Tag/Woche/Monat",

  // Error Log
  LblErrorLog: "Fehlerprotokoll",
  LblComponentName: "Komponentenname",
  LblLogType: "Protokolltyp",
  LblEventDateTime: "Ereignis DatumUhrzeit",
  LblComponent: "Komponente",
  LblMonitoring: "Überwachung",
  LblDropoffMessage: "Dropoff-Nachricht",
  LblPreferredlanguage: "Bevorzugte Sprache",
  LblDebtornr: "Schuldnernummer",

  // Interface Status
  LblInterfaceStatus: "Schnittstellenstatus",
  LblLastStatusChangeDateTime: "DatumUhrzeit letzte Statusänderung DatumUhrzeit",
  LblLastCarwisePollDateTime: "Letzte Carwise-Umfrage DatumUhrzeit",
  LblUpdatedDateTime: "DatumUhrzeit aktualisiert",

  //Booking Type
  LblNORMALBOOKINGTYPE: 'NORMAL',
  LblMAINTENANCEBOOKINGTYPE: 'WARTUNG',
  LblUNAVAILABLEBOOKINGTYPE: 'NICHTVERFÜGBAR',

  //Booking Request Status
  LblAPPROVEDBOOKINGREQUEST: 'ANGENOMMEN',
  LblREJECTEDBOOKINGREQUEST: 'ABGELEHNT',
  LblPENDINGBOOKINGREQUEST: 'AUSSTEHEND',

  //Booking Status
  LblABORTED: 'ABGEBROCHEN',
  LblCANCELLED: 'ANNULLIERT',
  LblCONFIRMED: 'BESTÄTIGT',
  LblFINISHED: 'FERTIG',
  LblNOSHOW: 'NOSHOW',
  LblPENDING: 'AUSSTEHEND',
  LblREVOKED: 'WIDERRUFFEN',
  LblRUNNING: 'GESTARTET',
  LblREADYFORPAYMENT: 'BEREIT FÜR DIE ZAHLUNG',

  //Invoice Status
  LblOPEN: 'OFFEN',
  LblSENT: 'GESENDET',
  LblCLOSED: 'ABGESCHLOSSEN',
  LblREQUESTFORPAYMENT: 'ZAHLUNGSANTRAG',
  LblREOPEN: 'ERNEUERT',

  //ErrorEscalation
  LblErrorEscalation: "Fehlereskalation",
  LblSelectAdminLevel: "Adminlevel auswählen",
  LblWegoAdminLevel: "WeGo-Adminlevel",
  LblCustomerAdminLevel: "Level Kundenadmin",
  LblInstanceAdminLevel: "Level Instanzadmin",

  //SharedVehicleGroup
  LblSharedVehicleGroup: "Carsharing-Gruppe",
  LblVehicleGroup: "Fahrzeuggruppe",
  LblSharedVehicleGroupAdmin: "Admin Carsharing-Gruppe",
  LblDisplayPeriod: "Anzeigeperiode",
  LblBookingWeekDays: "Buchung Wochentage",
  LblBookingInterval: "Buchungsintervall (Minuten)",
  LblBookingStartTime: "Startzeitpunkt Buchung (hh.mm)",
  LblBookingEndTime: "Endzeitpunkt der Buchung (hh.mm)",
  LblBookingMinDuration: "Minimale Buchungsdauer (Minuten)",
  LblBookingMaxDuration: "Maximale Buchungsdauer (Minuten)",
  LblMaxRecurringBooking: "Maximum wiederkehrende Buchung",
  LblPreBookingInterval: "Intervall vor Buchungen (Minuten)",
  LblPostBookingInterval: "Intervall nach Buchungen (Minuten)",
  LblBookingExtensionTime: "Maximale Verlängerungszeit (Minuten)",
  LblBookAheadTime: 'Buchung ab jetzt für «X» Minuten möglich',
  LblBookingHorizon: "Buchungszeitraum",
  LblNumberOfContactTypeGroup: "Anzahl Vertragstypengruppe",
  LblNumberOfContactType: "Anzahl Vertragstypen",
  LblInvoiceInterval: "Rechnungsintervall",
  LblIsBookingIntervalAlignToCalendar: "Buchungsintervall an Kalender angleichen",
  LblBookings: "Buchungen",
  LblSharedVehicleGroups: "Carsharing-Gruppen",
  LblSharedVehicleGroupOverview: "Übersicht Carsharing-Gruppe",
  LblEarlyOpenInterval: "Voraböffnungsintervall (Minuten)",
  LblFeatureFlags: "Feature-Flags",
  LblCreateBooking: "Buchung erstellen",
  LblEditBooking: "Buchung bearbeiten",
  LblLicenseCheck: "Lizenzprüfung",
  LblBookingLicenseCheck: "Überprüfen vor Buchung",

  //Driver
  LblDriver: "Fahrer",
  LblLicenceNumber: "Führerscheinnr.",
  LblDriverName: "Name des Fahrers",
  LblDriverSVG: "Fahrer Carsharing-Gruppe",
  LblDriverUserName: "Benutzername des Fahrers",

  //VehicleAttribute
  LblVehicleAttributeCategory: "Fahrzeugattributkategorie",
  LblVehicleAttributeName: "Attributname",
  LblVehicleAttributeDesc: "Beschreibung",
  LblVehicleAttribute: "Fahrzeugattribut",
  LbAdditionallVehicleAttribute: "Zusätzliche Fahrzeugmerkmale",
  LblVehicleAttributeCategories: "Fahrzeugattributkategorien",

  //ContractType Page
  LblRegular: "Regelmässig",
  LblWeekEnd: "Wochenende",
  LblDayCT: "Tag",
  LblExtraTimeBefore: "Zusätzliche Zeit vor (Minute)",
  LblExtraTimeAfter: "Zusätzliche Zeit nach (Minute)",
  LblFreeTextDescription: "Geben Sie den Sonderbuchungstarif sowie Start- und Endzeitpunkte an (Freitext)",
  LblPeriodRate: "Periodensatz",
  LblPeriodRateVat: "Periodensatz MWST",
  LblSelectContractTypeType: "Vertragstyp auswählen",
  LblContractTypeType: "Vertragstyp",
  LblContractType: "Vertragstyp",
  LblContractName: "Vertragsname",
  LblContractTypeGroup: "Vertragstypengruppe",
  LblContractTypeGroupName: "Name der Vertragstypengruppe",
  LblContractAvailableDays: "Verfügbare Tage Vertrag",
  LblApplicableDays: "Anwendbare Tage",
  LblDayStartTime: "Startzeitpunkt (hh.mm)",
  LblDayEndTime: "Endzeitpunkt (hh.mm)",
  LblApplicableStartTime: "Anwendbarer Startzeitpunkt (hh.mm)",
  LblApplicableEndTime: "Anwendbarer Endzeitpunkt (hh.mm)",
  LblComment: "Kommentar",
  LblProcessingFee: "Verarbeitungsgebühr",
  LblVatPercentage: "MWST (%)",
  LblVatIncludedInPrice: "MWST im Preis enthalten",
  LblPlateformUsageCost: "Nutzungskosten Plattform",
  LblCatA: "Kategorie A",
  LblCatB: "Kategorie B",
  LblCatC: "Kategorie C",
  LblCatD: "Kategorie D",
  LblCatE: "Kategorie E",
  LblCatF: "Kategorie F",
  LblCatG: "Kategorie G",
  LblCatH: "Kategorie H",
  LblHourlyRate: "Zeitkosten",
  LblMileageRate: "Kilometergeld",
  LblFixedFee: "Fixgebühr",
  LblPricingModel: "Preismodell",
  LblContractStartDateTime: "Startdatum/Startzeitpunkt Vertrag",
  LblContractEndDateTime: "Enddatum des Vertrags",
  LblContractTypeHistory: "Historie",
  LblContractTypPeriod: "Vertragstypenperiode",
  LblInactiveContractTypeGroupReason:
    "Grund für die Deaktivierung der Vertragstypengruppe",
  LblPenaltyAmount: "Höhe der Strafe",
  LblPenaltyTimeInterval: "Intervall Strafzeit (Minuten)",
  LblIsPenaltyEnabled: "Strafe aktiviert",
  LblTripDisplayType: "Wie sollen Fahrten in Berichten dargestellt werden?",
  LblAllTripsIndividually: "Alle Fahrten individuell",
  LblAllTripsGrouped: "Alle Fahrten in einer einzelnen Fahrt gruppiert",

  // DateTime Picker
  LblJanuary: "Januar",
  LblFebruary: "Februar",
  LblMarch: "März",
  LblApril: "April",
  LblMay: "Mai",
  LblJune: "Juni",
  LblJuly: "Juli",
  LblAugust: "August",
  LblSeptember: "September",
  LblOctober: "Oktober",
  LblNovember: "November",
  LblDecember: "Dezember",

  LblSJan: "Jan",
  LblSFeb: "Feb",
  LblSMar: "März",
  LblSApr: "Apr",
  LblSMay: "Mai",
  LblSJun: "Juni",
  LblSJul: "Juli",
  LblSAug: "Aug",
  LblSSep: "Sep",
  LblSOct: "Okt",
  LblSNov: "Nov",
  LblSDec: "Dez",

  LblSunday: "Sonntag",
  LblMonday: "Montag",
  LblTuesday: "Dienstag",
  LblWednesday: "Mittwoch",
  LblThursday: "Donnerstag",
  LblFriday: "Freitag",
  LblSaturday: "Samstag",

  LblSSu: "So",
  LblSMo: "Mo",
  LblSTu: "Di",
  LblSWe: "Mi",
  LblSTh: "Do",
  LblSFr: "Fr",
  LblSSa: "Sa",

  //Forgot Password
  LblForgotPassword: "Passwort vergessen",
  LblChangePassword: "Passwort ändern",
  LblOldPassword: "Altes Passwort",
  LblNewPassword: "Passwort",
  LblProfileUpdatedSucessFully: "Profilaktualisierung erfolgreich",
  LblPasswordChangedSucessFully: "Sie haben Ihr Passwort erfolgreich geändert",

  //
  LblUpdateProfile: "Profil aktualisieren",
  LbLReasonVehicle: "Grund für Nichtverfügbarkeit",
  LblReasonDriver: "Grund für Fahrerblockierung",

  //Booking
  LblFrom: "Von",
  LblApprovalAdminName: "Vom Admin genehmigt",
  LblApprovedRejectedby: "Genehmigt/Abgelehnt von",
  LblBookingRequestList: "Liste Buchungsanfragen",
  LblTo: "Bis",
  LblBooking: "Buchung",
  LblBookingRequest: "Buchungsanfrage",
  LblOverview: "Buchungsübersicht",
  LblOverviewList: "Liste Buchungsübersicht",
  LblApproveBooking: "Buchungsgenehmigung",
  LblApprove: "Genehmigen",
  LblReject: "Ablehnen",
  LblNormal: "Neue Buchung",
  LblSpecial: "Sonderbuchung",
  LblHistory: "Buchungshistorie",
  LblBookingStatus: "Buchungsstatus",
  LblBookingType: "Buchungstyp",
  LblAdminRemarks: "Bemerkungen Admin",
  LblBookingRemarks: "Anmerkungen zur Buchung",
  LblDriverRemarks: "Anmerkungen des Fahrers",
  LblBookingReferenceId: "Buchungs-ID",
  LblAbort: "Abbrechen",
  LblRevoke: "Widerrufen",
  LblStatus: "Status",
  LblReference: "Referenz-ID",
  LblRemarks: "Anmerkungen",
  LblSearchForVehicle: "Fahrzeug suchen",
  LblVehicleOverview: "Fahrzeugübersicht",
  LblConfirmBooking: "Buchung bestätigen",
  LblCurrentBookingDetail: "Informationen zur aktuellen Buchung",
  LblCheckAvailability: "Verfügbarkeit prüfen",
  LblBookingStartDateTime: "Beginn Buchung",
  LblBookingEndDateTime: "Ende der Buchung",
  LblSource: "Quelle",
  LblRecurring: "Wiederkehrend",
  LblRecurringId: "Wiederkehrende ID",
  LblRecurringBookingReference: "Wiederkehrende Buchungsreferenz",
  LblDaily: "Täglich",
  LblWeekly: "Wöchentlich",
  LblMonthly: "Monatlich",
  LblRecurrenceEndDate: "Enddatum Wiederholung",
  LblSearch: "Suchen",
  LblBookNow: "Jetzt buchen",
  LblUpdateBooking: "Buchung aktualisieren",
  LblEditCarNotAvailable: "Ursprünglich gebuchtes Fahrzeug nicht verfügbar",
  LblSortBy: "Sortieren nach",
  LblAvaibility: "Verfügbarkeit",
  LblDistance: "Distanz",
  LblNoMatchingVehicle: "Keine passenden Fahrzeuge gefunden",
  LblAvailableSlots: "Verfügbare Zeitfenster",
  LblFeatures: "Funktionen",
  LblDriverDetail: "Fahrerinformationen",
  LblBookingDetail: "Buchungsinformationen",
  LblVehicleDetail: "Fahrzeugdetails",
  LblBookingSuccess:
    "Sie haben die Buchungsanfrage erfolgreich erstellt. Eine Kopie der Anfrage wird an die registrierte E-Mail-Adresse gesendet. Es wurde auch eine Benachrichtigung zur ",
  LblBookingUpdateSuccess:
    "Buchung wurde erfolgreich angepasst. Eine Benachrichtigung wird an die E-Mail-Adresse des Fahrers gesendet.",
  LblBlockNormalBooking:
    "Ihr Account wurde blockiert. Bitte wenden Sie sich an den Administrator.",
  LblSingle: "Einzeln",
  LblSeries: "Serie",
  LblAll: "Alle",
  SelectionRequiredMsg: "Bitte wählen Sie mindestens eine Buchung aus, um sie zu genehmigen/abzulehnen",
  LblSelectionRequired: "Auswahl erforderlich",
  LblLicenceRequired1: "Bitte Führerscheinnummer validieren, gehen Sie auf",
  LblLicenceRequired2: "um Einzelheiten zur Führerscheinnummer zu aktualisieren",
  LblAcceptOrReject: "Genehmigen/Ablehnen",

  //Special Booking
  LblSpecialBooking: "Sonderbuchung",
  LblAffectedBooking: "Betroffene Buchungen",
  LblSpecialBookingType: "Sonderbuchungstyp",
  LblSelectSpecialBookingType: "Sonderbuchungstyp auswählen",
  LblSpecialBookingConfiramtionmsg:
    "Möchten Sie wirklich eine Sonderbuchung erstellen?",
  LblEndDate: "Enddatum Wiederholung",

  // Notification
  LblNotification: "Benachrichtigung",
  LblSubject: "Betreff",
  LblDate: "Datum",
  LblWelcomeNotification: "Willkommen zum WeGo-Benachrichtigungspostfach",

  //Template
  LblTemplate: "Vorlage",
  LblTemplateList: "Vorlagenliste",
  LblTemplateName: "Vorlagenname",
  LblTemplateType: "Vorlagentyp",
  LblBody: "Karosserie",
  LblIsEmailTemplate: "E-Mail",
  LblIsWebTemplate: "Web",

  // Notification Event Management
  LblNotificationEventManagement: "Benachrichtigungsereignisse Management",
  LblNotificationEvent: "Benachrichtigungsereignis",

  LblModuleName: "Modulname",
  LblSMS: "SMS",
  //User Type
  LblUserType: "Nutzertyp",

  //TimeBlock

  LblTimeBlock: "ZeitBlock",
  LblTimeBlockName: "ZeitBlock Name",
  LblTimeBlockWeekDays: "ZeitBlock Wochentage",

  LblTimeBlockStartTime: "ZeitBlock Startzeitpunkt",

  LblTimeBlockEndTime: "ZeitBlock Endzeitpunkt",

  LblTimeBlockStartDate: "ZeitBlock Startdatum",

  LblTimeBlockEndDate: "ZeitBlock Enddatum",

  // Service Offer
  LblServiceOffer: "Dienstleistungsangebot",
  LblServiceOfferList: "Liste Dienstleistungsangebot",
  LblServiceOfferName: "Angebotsname",
  LblServiceOfferType: "Angebotstyp",
  LblStandardTariff: "Standardtarif",
  LblTimeUsedOrBooked: "Zeit genutzt/gebucht",
  LblPenalty: "Strafe  ",
  LblAdditional: "Zusätzlich",
  LblAdditionalAbbr: "Zusätzlich",
  LblUnit: "Einheit",

  //WegoAdminList
  LblWegoAdmin: "WeGo-Admin",
  LblWegoAdmins: "WeGo-Admins",

  LblReSend: "Erneut senden",
  LblResendActivationMail: "Aktivierungs-E-Mail",
  LblResendActivationMailFailure: "Senden der Aktivierungs-E-Mail fehlgeschlagen",
  LblResendActivationMailSuccess: "Aktivierungs-E-Mail gesendet",

  //Subscription
  LblSubscription: "Abonnement",
  LblSubscriptionName: "Abonnementname",
  LblTimeInterval: "Zeitintervall",
  LblAmount: "Anzahl",
  LblFreeKilometer: "Freicredits",
  LblFreeMinute: "Freiminuten",
  LblFreeHours: "Freistunden",
  LblNumberOfSubscription: "Anzahl Abonnements",
  LblUnsubscribe: "Abmelden",
  LblsubscribeEndDate: "Enddatum Abonnement",
  LblSubscriptionStartDate: "Startdatum Abonnement",
  //Special Period
  LblSpecialPeriod: "Sonderperiode",
  LblspecialPeriodName: "Name der Sonderperiode",
  LblSpecialPeriodStartTime: "Startzeitpunkt der Sonderperiode",
  LblSpecialPeriodEndTime: "Endzeitpunkt Sonderperiode",
  LblSpecialPeriodWeekDays: "Sonderperiode Wochentage",
  LblNormalPeriod: "Normaler Zeitraum",
  LblSpecialPeriods: "Sonderperioden",
  //Booking InvoiceModel
  LblBookingInvoice: "Buchungsrechnung",
  LblInvoiceStatus: "Rechnungsstatus",
  LblInvoiceType: "Rechnungstyp",
  LblSummary: "Zusammenfassung",
  LblTotalHours: "Stunden insgesamt",
  LblTotalKm: "Strecke insgesamt (km)",
  LblTotalExpense: "Gesamtausgabe",
  LblInvoiceNumber: "Rechnungsnummer",
  LblBegin: "Start",
  LblEnd: "Ende",
  LblVat: "MWST",
  LblDone: "Fertig",
  LblClear: "Löschen",
  LblTotal: "Total",
  LblInvoiceRequestDateTime: "Rechnungsanforderung DatumUhrzeit",
  LblInvoiceSendDateTime: "Rechnung versenden DatumUhrzeit",
  LblInvoiceDateTime: "Rechnung DatumUhrzeit",
  LblInvoiceDetail: "Rechnungsdetails",
  LblResend: "Erneut senden",
  LblDownload: "Herunterladen",
  LblResendInvoiceConfirm:
    "Möchten Sie %0 wirklich erneut versenden?",
  LblSendInvoiceConfirm: "Möchten Sie die Rechnung wirklich senden?",
  LblPenaltyRate: "Straftarif",
  LblInvoicing: "Rechnungsstellung",
  LblInvoices: "Rechnungen",
  LblLegacyInvoicing: "Rechnungen (vor dem 22.04.2025)",

  LblProfile: "Profil",
  LblSignOut: "Abmelden",
  LblTemplateNote1:
    "Bitte Texte in Form von {variablename} nicht ändern/entfernen. Dies ist ein dynamischer Attributname, der durch einen tatsächlichen Datenbankeintrag ersetzt wird, wenn die E-Mail an den Benutzer gesendet wird.",
  LblTemplateNote2:
    "Bitte die Struktur der Tabellen nicht ändern. Sie können eine neue erstellen, die alte sollte jedoch nicht geändert werden.",
  LblTemplateNote3:
    "Bitte achten sie darauf, dass Sie «Einfügen als normaler Text» wählen, wenn Sie einen Platzhalter kopieren und im HTML-Editor einfügen.",

  LblConfirmUnsubscribe: "Möchten Sie sich wirklich abmelden?",
  LblDriveHours: "Fahrzeiten",
  LblVehicleImage: "Fahrzeugbild",
  LblMaintenance: "Wartung",
  LblUNAVAILABLE: "Nicht verfügbar",
  LblTestInvoiceGenerator: "Generator Testrechnung",
  LblMissingInvoiceGenerator: "Fehlender Generator Rechnung",
  LblInvoicingDateTime: "Rechnungsstellung DatumUhrzeit (UTC)",
  LblGenerateInvoice: "Rechnung generieren",
  LblDeleteAllSelectedRecords: "Alle markierten Einträge löschen",
  LblCancelAllSelectedRecords: "Alle markierten Einträge annullieren",
  "LblExportAll(CSV)": "Alle exportieren (CSV)",
  LblAddContactPerson: "Ansprechpartner hinzufügen",
  LblRemoveContactPerson: "Ansprechpartner entfernen",
  LblNote: "Anmerkung",
  LblCompletelyEndConfirm: "Fahrt vollständig abschliessen",
  LblEndTrip: "Fahrtende",
  LblTestTrip: "Testfahrt",
  LblTripSimulator: "Fahrtsimulator",
  LblTestTripSuccess: "Testfahrt erfolgreich erstellt",
  LblDrivingStartDateTime: "Enddatum/Startzeitpunkt der Fahrt",
  LblDrivingEndDateTime: "Enddatum/Endzeitpunkt der Fahrt",
  LblInvoiceMoment: "Rechnungszeitpunkt",
  LblExtend: "Verlängern",
  LblExtendRequire:
    "Bitte geben Sie die Buchungsverlängerung ein (Minuten)",
  LblExtendInfoMsg: "Sie können die Buchung um maximal %0 Minuten verlängern",
  LblExtendValidationMsg: "Diese Buchung kann nicht verlängert werden",
  LblExtendBooking: "Buchung verlängern",
  LblBookingExtendedSuccess: "Buchung erfolgreich verlängert",
  LblOverExtendValidationMsg:
    "Die Buchung kann nicht um mehr als %0 Minuten erweitert werden",
  LblUnLock: "Entriegeln",
  LblLock: "Sperren",
  LblVehicleStatus: "Fahrzeugstatus",
  LblTripSuccess: "Fahrt erfolgreich gespeichert",

  LblLockSuccessfully: "Fahrzeug erfolgreich verriegelt",
  LblLockCompletelySuccessfully: "Fahrzeug erfolgreich verriegelt",
  LblUnLockSuccessfully: "Fahrzeug erfolgreich entriegelt",
  LblUnlockProblem: "Problem bei Entriegelungsbefehl",
  LbllockProblem: "Problem bei Verriegelungsbefehl",
  LblLockCarCompletely: "Buchung sperren und schliessen",
  LblStartDateTime: "Startdatum/Startzeitpunkt",
  LblEndDateTime: "Enddatum/Endzeitpunkt",
  LblBookingTripDetail: "Fahrtdetails für Buchung",
  LblAddNewTrip: "Neue Fahrt hinzufügen",
  LblBookingExpenseDetail: "Details Buchungsausgaben",
  LblUnlockErrorMessage:
    "Keine aktive Vertragstypengruppe zum Erstellzeitpunkt der Buchung verfügbar",

  LblExpenseAmount: "Betrag Ausgaben",
  LblExpenseName: "Name Ausgaben",
  LblExpenseSuccess: "Ausgaben erfolgreich gespeichert",
  LblReceipt: "Beleg",
  LblHelpdeskNo: "Helpdesk-Nr.",
  LblBookingExpired:
    "Fahrzeug kann nicht geöffnet werden, da die Buchung abgelaufen ist.",
  LblTripCalculationInProgress:
    "Wir hoffen, dass Sie eine gute Fahrt hatten! Das Fahrzeug wird sich in wenigen Sekunden schliessen.",

  LblVTSReqLogDetail: "VTS-Anforderung Protokolldetails",
  LblVTSReqDateTime: "Datum/Uhrzeit anfordern",
  LblVTSProcessTime: "Bearbeitungszeit",
  LblVTSResTime: "Ergebniszeit",
  LblVTSReqType: "Anforderungstyp",
  LblVTSResult: "Ergebnis ",
  LblActualInvoiceGenerationDate: "Tatsächliches Datum der Rechnungsgenerierung",
  LblAvailableForAllSlots: "Fahrzeug verfügbar für alle Zeitfenster",
  LblUnAvailableSlots: "Nicht verfügbare Zeitfenster",
  LblNoOfDrivers: "Anzahl Fahrer",
  LblSVGDriversList: "Fahrer Carsharing-Gruppe",
  LblVehicleInformation: "Fahrzeuginformationen",
  LblVTSVehicle: "VTS-Fahrzeug",
  LblVTSVehicleUpdateSuccess: "Fahrzeug erfolgreich %0.",
  LblVTSVehicleList: "VTS-Fahrzeugliste",

  //Report Damage
  LblReportDamage: "Schaden melden",
  LblCompleteDamageReport: "Schadensmeldung abschliessen",
  LblDamageFile: "Schadendatei",
  LblDescribe: "Beschreiben Sie den Schaden ...",
  LblCause: "Beschreiben Sie die Ursache ...",
  LblReportDamageMsg: "Schaden erfolgreich gemeldet",
  LblSelectFile: "Datei auswählen",

  // Import Data
  LblCSVImport: "CSV-Datei importieren",
  LblValidateCSV: "CSV validieren",
  LblImportValidPerson: "Gültige Person importieren",
  LblImportValidDriver: "Gültigen Fahrer importieren",
  LblImportValidVehicle: "Gültiges Fahrzeug importieren",
  LblCSVType: "CSV-Typ",
  LblCSVFile: "CSV-Datei",
  LblRecordImportedSuccess: "%0 wurden erfolgreich importiert",
  LblInvalidReason: "Ungültiger Grund",
  LblSameVTSCommand:
    "Anfrage wird bereits bearbeitet. Bitte warten Sie.",
  LblImportPerson: "Person importieren",

  //Subscription related Changes
  LblSubscriptionInterval: "Abonnementintervall",
  LblPaymentInterval: "Zahlungsintervall",
  LblInvoicInterval: "Rechnungsintervall",
  LblInterval: "Intervall",
  LblInvoiceMomentDay: "Rechnungszeitpunkt (Wochentag)",
  LblInvoiceMomentMonth: "Rechnungszeitpunkt (Tag des Monats)",
  LblFreeMinuteInterval: "Freiminuten Intervall",
  LblFreeKMInterval: "Freicredits Intervall",
  LblSelectSubscriptionInterval: "Abonnementintervall auswählen",
  LblSelectInvoiceInterval: "Rechnungsintervall auswählen",
  LblSelectPaymentInterval: "Zahlungsintervall auswählen",
  LblSelectFreeKMInterval: "Intervall Freikilometer auswählen",
  LblSelectFreeMinInterval: "Minutenintervall auswählen",
  LblYearlySub: "Jährlich",
  LblMonthlySub: "Monatlich",
  LblWeeklySub: "Wöchentlich",
  LblFreePerWeek: "Pro Woche",
  LblFreePerMonth: "Pro Monat",
  LblFreePerTriMonth: "Pro 3 Monate",
  LblFreePerBiannual: "Pro 6 Monate",
  LblFreePerYear: "Pro Jahr",
  LblDefaultContractTypeGroup: "Standard-Vertragstypengruppe",
  LblSelectDefaultContractTypeGroup:
    "Standard-Vertragstypengruppe auswählen",
  LblSendInvoiceToDriver: "Rechnung an Fahrer senden",
  LblInherit: "übernehmen",

  //Invoice Moment
  LblDayOfMonth: "Tag des Monats",
  LblDayOfWeek: "Wochentag",
  LblSelectDayOfWeek: "Wochentag auswählen",
  LblInstanceLogo: "Instanzlogo",
  LblInvoiceDeleteValidation:
    "Rechnung kann nicht gelöscht werden wegen Verknüpfung mit anderer Einheit",

  //SubscriptionAvailabilityRestriction
  LblSubscriptionAvailabilityRestriction:
    "Verfügbarkeitsbeschränkung Abonnement",
  LblStartDay: "Starttag",
  LblEndDay: "Endtag",
  LblStartTime: "Startzeitpunkt (hh.mm)",
  LblEndTime: "Endzeitpunkt (hh.mm)",
  LblRestriction: "Beschränkung",
  LblTotalFreeKilometer: "Freikilometer insgesamt",
  LblTotalFreeMinute: "Freiminuten insgesamt",
  LblCurRemainFreeKilometer: "Verbleibende Freikilometer",
  LblPrevRemainFreeKilometer: "Vorherige verbleibende Freikilometer",
  LblCurRemainFreeMinute: "Verbleibende Freiminuten",
  LblPrevRemainFreeMinute: "Vorherige verbleibende Freiminuten",
  LblResetPasswordFailure:
    "Das Passwort kann nicht zurückgesetzt worden, da der Benutzer noch nicht aktiviert ist.",

  //Additional Free Item
  LblAdditionalFreeItems: "Zusätzliches Gratis Credits",
  LblDateAwared: "Zuerkennungsdatum",
  LblAdditionalFreeItemsMenu: "Zusätzliche Gratis Credits",

  LblPrevious: "Vorherige",
  LblCurrent: "Aktuell",

  LblTripDetailReport: "Fahrtdetailbericht",
  LblTripDetailList: "Detaillierte Buchungsübersicht",
  LblSearchTripforDriver: "Gebuchte Fahrten von Fahrer suchen",
  LblExportReport: "Bericht exportieren",

  LblTripComments: "Fahrt bemerkung",
  LblTripCommentDescription: "Bemerkung eingeben",
  LblTripCommentError: "Bitte gültige bemerkung eingeben",
  LblShowTripComment: "Bemerkung ansehen",
  LblAddTripComment: "Bemerkung eingeben",
  LblTripCommentBy:"Fahrt bemerkung von",
  LblTripCommentOn: "Fahrt bemerkung am",

  LblValidateLiceanceNumberMessage:
    "Bitte validieren Sie Ihre Führerscheinnummer",
  LblBookingIntervalRate: "Intervalltarif",
  LblPerHour: "Pro Stunde",
  LblPerBookingIntarval: "Pro Buchungsintervall",
  LblTimeRate: "Zeittarif",
  LblToalBookingDuration: "Buchungsdauer",

  LblCleanRequire: "Reinigung erforderlich",
  LblFualRequire: "Kraftstoff erforderlich",
  LblVehicleDamageList: "Liste für Fahrzeugschaden",
  LblDamageCause: "Schadensursache",
  LblDamageReportedBy: "Gemeldet von",
  LblDamageReportedOn: "Gemeldet am",
  LblConfirmResolveDamage:
    "Möchten Sie den Fahrzeugschaden wirklich beheben?",
  LblVehicleDamgeResolveSuccess: "Fahrzeugschaden erfolgreich behoben",
  LblDamageDesc: "Schadensbeschreibung",
  LblFutureBooking: "Künftige Buchungen",
  LblResolveDamge: "Schaden beheben",
  LblReserved: "Reserviert",
  LblVehicleInfoSuccess: "Fahrzeuginformationen erfolgreich aktualisiert",
  LblInformation: "Information ",

  LblVTSHistory: "VTS-Ereignishistorie",

  LblWegoRequestTime: "WeGo-Anfragebearbeitungszeit",
  LblVTSRequestTime: "VTS-Anfragebearbeitungszeit",
  LblRequestType: "Anforderungstyp",
  LblWegoProcessTime: "WeGo-Bearbeitungszeit",
  LblResult: "Ergebnis",
  LblWegoResultTime: "WeGo-Ergebniszeit",
  LblVTSResultTime: "VTS-Ergebniszeit",

  LblCommandInitiator: "Anfrage gesendet von",

  LblTroubleShootVTS: "VTS-Fehlerbehebung",

  LblVtsServiceStatus: "VTS-Servicestatus",
  LblVtsLicencetag: "VTS-Kennzeichen",
  LblVtsDoorStatus: "Türstatus",
  LblVtsIssueCommand: "Befehl senden",
  LblVehicleLocation: "Fahrzeugstandort",
  LblEventHistory: "VTS-Ereignishistorie",

  LblView: "Ansehen",
  LblVehicleObuStatus: "Bordgerätstatus Fahrzeug",

  LblVehicleNotInitialized: "Fahrzeug nicht initialisiert",
  LblLastReceivedTime: "Zeit letzte erhaltene Nachricht",

  LblFreePerBookingInterval: "Pro Buchungsintervall",

  LblSelectFilter: "Filter auswählen",
  LblAuditEntries: "Einträge prüfen",
  LblFilter: "Filter ",
  LblCategory: "Kategorie",
  LblEventName: "Ereignisname",
  LblEventData: "Ereignisdaten",
  LblMoment: "Moment",
  LblUser: "Nutzer",
  LblNoEventDataFound: "Keine Ereignisdaten gefunden",
  LblEventViewer: "Ereignisviewer",
  LblSelectObuType: "Bordgerättyp auswählen",

  LblObuType: "Bordgerättyp",
  LblDeviceId: "Geräte-ID",
  LblClaimCode: "Claim code",

  LblVtsLocation: "VTS-Standort",
  LblRetriveAddress: "Adresse abrufen",
  LblCrearedDate: "Erstelldatum",
  LblCreatedBy: "Erstellt durch",
  LblPerBooking: "PerReservierung",

  LblOBU: "Bordgerät",
  LblClone: "Kopieren",
  LblCloneVehicle: "%0 kopieren",
  LblFualNotRequire: "Kraftstoff nicht erforderlich",
  LblCleanNotRequire: "Reinigung nicht erforderlich",

  LblSubscriptionInfo: "Abonnementinformationen",
  LblVehiclDamaged: "Fahrzeug beschädigt",
  LblVehicleNotDamaged: "Fahrzeug nicht beschädigt",
  LblDamage: "Beschädigt",
  LblFreeBooking: "Buchungskosten anpassen",
  LblBookingCustomFee: "Benutzerdefinierte Buchungskosten",
  LblFreeBookingSuccess: "Buchungskosten erfolgreich gespeichert",
  LblEnterLocation: "Standort eingeben",
  LblHomeLocation: "Heimatstandort",
  LblLocationMode: "Standortmodus",
  LblMeter: "Meter",
  LblLocation: "Standort",
  LblPickupLocation: "Abholort",
  LblLocationUnavailable: "Standort nicht verfügbar",
  LblAvailabilityCalander: "Verfügbarkeitskalender",
  LblAvailableOn: "Verfügbar auf",
  LblGeofenceEnabled: "Geofence aktiviert",
  LblLocationNotFound: "Adresse kann nicht gefunden werden",
  LblAddressNotAvailable:
    "Adresse kann an diesem Standort nicht bestimmt werden",

  LblReports: "Berichte",
  LblDrivers: "Fahrer",
  LblTemplates: "Vorlagen",

  LblVehicleOccupancyReport: "Fahrzeugbelegungsbericht",
  LblPlaceHolder: "Platzhalter",
  LblSampleTemplate: "Mustervorlage",

  LblLatexFileDownloadValidation: "Ungültiger Latex-Inhalt",
  LblLocationDataExchangeNotAssign:
    "Dieses Fahrzeug kann nicht gebucht werden, wenn ihm kein VTS-Fahrzeug zugewiesen ist. Möchten Sie fortfahren?",
  LblReservedTime: "Reservierte Zeit",
  LblUsageTime: "Nutzungsdauer",
  LblUsageTimeAtOffice: "Nutzungsdauer während der Arbeitszeit",
  LblUsageTimeoutOffice: "Nutzungsdauer ausserhalb der Arbeitszeit",
  LblRevenue: "Erlös",
  LblRevenuePerVehicleReport: "Bericht Erlös pro Fahrzeug",
  LblSearchRevenuePerVehicle: "Erlös pro Fahrzeug suchen",
  LblRevenuePerVehicleList: "Liste Erlös pro Fahrzeug",

  //Dashboard
  LblInuse: "In Benutzung",
  LblPriority: "Priorität",
  LblDefaultStatus: "Standardstatus",

  //OdometerLogTrail
  LblOdometerLogTrail: "Historie Kilometerzähler",
  LblUserProvidedOdometerValueInKmr: "Kilometerstand (km)",
  LblDescriptionOfDeviation: "Beschreibung Abweichung",
  LblFromOdometer: "Aus Kilometerzähler",
  LblToOdometer: "Zum Kilometerzähler",
  LblAddDescriptionOfDeviation: "Erklärung für Abweichung hinzufügen",
  LblDeviation: "Abweichung (km)",

  LblLastOdometerValue: "Vorheriger Kilometerstand (km)",
  LblLastOdometerDT: "Vorheriges Kilometerzählerdatum",

  LblOdometerRegistered: "Kilometerstand registriert",
  LblOdometerValue: "Kilometerstand",
  LblMaintenancePlanningList: "Liste Wartungsplanung",
  LblSearchMaintenancePlanningValue: "Wartungsplanung durchsuchen",
  LblMaintenancePlanningreport: "Bericht Wartungsplanung",

  LblodometerConfiguration: "Konfiguration Kilometerzähler",
  LbLOdometerEnabled: "Kilometerzähler aktiviert",
  LblEnableOnApp: "In App aktivieren",
  LblWarningPer: "Warnung (%)",
  LblShowDeviation: "Abweichung anzeigen, die eine Erklärung erfordert",

  LblTitle: "Titel",
  LblFooterText: "Fussnotentext",
  LblvalidEmailDomain: "Nur E-Mail-Adressen der folgenden Domäne erlauben",
  LblURLSettings: "URL-Einstellungen",
  LblSuccessUrl: "Erfolg URL",
  LblEmailSettings: "E-Mail-Einstellungen",
  LblSendActivationEmail: "Automatische Aktivierungs-E-Mails aktivieren",
  LblSendConfirmationEmail: "Bestätigungs-E-Mails Registrierung aktivieren",

  LblRequireAdminApprovel: "Neue Registrierungen erfordern Genehmigung des Admins",
  LblDriverInformationToBeInclude: "Fahrerinformationen müssen im Formular eingetragen werden (alle erforderlichen Felder)",
  LblSignUpForm: "Registrierungsformular",
  LblSignupForms: "Registrierungsformulare",
  LblSignupFormsOverview: "Übersicht Registrierungsformulare",
  LblWhoCanApprove: "Wer kann neue Registrierungen bestätigen?",
  LblSignupFormLogo: "Logo Registrierungsformular",
  LblChooseSubscription: "Wählen Sie das/die für das Registrierungsformular verfügbare(n) Abonnement(s)",
  LblSignupParameter: "Registrierungs-URL",
  DomainNameString: "Domänennamen durch Komma getrennt (Beispiel: gmail.com, yahoo.com)",
  SignupParameterString: "Nur Buchstaben, Zahlen und - sind erlaubt",
  LblSignupParameterText: "Text Registrierungs-URL",

  LblAvailability: "Verfügbarkeit",
  LblSettings: "Einstellungen",
  LblCurrentStatus: "Aktueller Status",
  LblFlags: "Flags",
  LblNA: "Keine Angabe",

  //Sign up form
  LblConfirmEmail: "E-Mail-Adresse bestätigen",
  LblSignup: "Registrieren",

  LblSignupsOverView: "Registrierungsübersicht",
  LblSignupApproval: "Registrierungsbestätigung",
  LblAccept: "Akzeptieren",
  LblSignupFormDescription: "Beschreibung Registrierungsformular",

  LblCurrentOdometerValue: "Aktueller Kilometerstand",
  LblCurrentOdometerDateTime: "Aktuelles Datum/aktuelle Uhrzeit Kilometerzähler",

  LblCreateDirectDebitFile: "Lastschriftdatei erstellen",
  LblCheckEmptyIbanNumber: "IBAN-Nummern prüfen",
  LblCreatedDate: "Erstelldatum",
  LblIncludeInDirectDebit: "Lastschriftdatei einschliessen",
  LblDirectDebitFileDate: "Datum Lastschriftdatei",
  LblDirectDebitConfiguration: "Lastschriftkonfiguration",
  LbLDirectDebitEnabled: "Generierung Lastschriftdatei aktivieren",
  LblDirectDebitEnableper: "Lastschriftdatei aktiviert per",
  LbLCreditorDetails: "Angaben zum Gläubiger",
  LblAddress: "Adresse",
  LblIBANNumber: "IBAN",
  LblCountryCode: "Ländervorwahl",
  LbLBillingInformation: "Zahlungsinformation",

  LblFormat: "Format",
  LblInvoicingDetails: "Details Rechnungsstellung",
  LbLSubjectToDirectDebit: "Der Lastschrift unterliegend?",

  //Person Upload Batch
  LblBatchUploadPersonSetting: "Einstellung für «Personen gesammelt importieren»",
  LblShowBatchUploadInfo: "«Personen gesammelt importieren» zulassen",
  LblAllowBatchUpload: "Import erlauben für",
  LblAllowActivationMail: "Aktivierungs-E-Mails benutzen",
  LblGenerateRandomPassword: "System generiert Passwörter",
  LblUserUploadPassword: "Passwörter importieren",
  LblFieldToUploadedOrValidated: "Felder in Importdatei",
  LblBatchUploadPerson: "Personen gesammelt importieren",
  LblBatchUpload: "Personen gesammelt importieren",
  LblImportDriverRole: "Fahrerrolle automatisch zuweisen?",
  LblAssignToSVG: "Carsharing-Gruppe(n) zuweisen",
  LblSVG: "Carsharing-Gruppe",
  LblDownloadTemplate: "Beispiel Importdatei",
  LblUserAssignSVGMessage: "Nutzer wurde Carsharing-Gruppe noch nicht zugewiesen!",
  LblInvalidRecordReason: "Ungültiger Eintrag",
  LblSelectedSVGs: "Ausgewählte Carsharing-Gruppe(n)",

  LblDashboard: "Dashboard",
  LblGroupAdmin: "Gruppenadmin",
  LblDashboardConfiguration: "Dashboard-Konfiguration",
  LblCurrentLocation: "Aktueller Standort",
  LblEnableCurrentLocation: "Aktueller Standort aktivieren",
  LblDefaultLocation: "Standardstandort",
  LblEnableAutoUpdate: "Automatische Aktualisierung aktivieren",
  LblPriorityNotificationSetting: "Benachrichtigungseinstellungen für Fahrzeugstatus",
  LblCollectionDate: "Datum Lastschrift",
  LblBICCode: "BIC-Code",
  LblDirectDebitFile: "Lastschriftdatei ",
  LblMissingIBANNumber: "Fehlende IBAN",

  LblCurrentDriver: "Aktueller Fahrer",
  LblNextDriver: "Nächster Fahrer",
  LblSecond: "Sekunde(n)",

  LblCleaning: "Reinigung",
  LblRefueling: "Auftanken/Aufladen",
  LblAPKMaintenance: "Periodische Wartung",
  LblOutsideGeofence: "Ausserhalb Geofence",
  LblNotBooked: "Nicht gebucht",
  LblNotBookedSince: "Nicht gebucht seit",
  LblLowBattery: "Niedriger Batteriestand",
  LblBatteryVolt: "V.",
  LblLowCharge: "Batterie beinahe leer",
  LblChargingPercentage: "%",

  LblOnSamePosition: "An derselben Position",
  LblLastPosition: "Letzte Position",
  LblNotReturn: "Nicht zurück",
  LblCommunicationProblem: "Kommunikationsproblem",
  LblDirectDebitDownloadSuccess: "Lastschriftdatei heruntergeladen",
  LblWarnings: "Warnungen",
  LblDirectDebitFileId: "Lastschriftdatei-ID",
  LblTotalAmount: "Gesamtbetrag",
  LblReCreate: "Erneut herunterladen",
  LblPleaseEnterCollectionDate: "Bitte geben Sie ein Abholdatum ein",

  LblOpenViaLowLevel: "Geöffnet über Low Level",
  LblInstanceNotificationNote1:
    "Einstellung erfolgt nach Unternehmensvorgabe",
  LblNoInvoiceSelected: "Keine Rechnung(en) für Lastschriftdatei gefunden",
  LblIBANNumberRequired: "Bitte geben Sie IBAN und BIC ein",
  LblNoEmptyIBANFound: "Keine IBAN gefunden",

  LblInvalidTagUsed: "Ungültiges Tag verwendet",
  LblNotInvalidTagUsed: "Keine ungültiges Tag verwendet",

  LblShowVehicleChargeLevel: "Fahrzeugbatteriestand im Web und in Mobiltelefon-Apps anzeigen?",
  LblChargeLevel: "Batteriestand",
  LblCharging: "Aufladen",

  LblNoDataFound: "Keine Daten verfügbar",
  LblOfficeStartTime: "Startzeitpunkt Geschäftszeiten (hh.mm)",
  LblOfficeEndTime: "Endzeitpunkt Geschäftszeiten (hh.mm))",
  //Reports
  LblTripDataReport: "Fahrtdatenbericht",
  LblByDriver: "Nach Fahrer",
  LblByVehicle: "Nach Fahrzeug",
  LblModuleRights: "Modulrechte",
  LblCostCenterReport: "Kostenstellenbericht",
  LblShowTotalOnly: "Nur Total anzeigen",
  // 'LblCostCenterReport':'Cost Center Report',
  //Organization
  LblOrganization: "Organisation ",
  LblOrganizationName: "Name Organisation",
  LblAddDriver: "Fahrer hinzufügen",
  LblExistingDriverAddSuccessMsg: "Fahrer hinzugefügt, ebenfalls erfolgreich mit der Organisation verbunden.",
  LblAddDriverSuccessMsg: "Fahrer hinzugefügt, Aktivierungslink ebenfalls erfolgreich an diesen Fahrer gesendet.",
  LblOrganizationAddress: "Adresse Organisation",
  LblAddDriverToOrganization: "Fahrer zur Organisation hinzufügen",
  LblCreateOrganization: "Organisation erstellen",
  LblOrganizationDriversList: "Fahrer Organisation",
  // Branding
  LblBranding: "Branding",
  LblLogo: "Logos",
  LblEmailNotificationInvoiceTemplate:
    "E-Mail-Benachrichtigung und Rechnungsvorlagen",
  LblExpandedWebMenu: "Ausgeklapptes Webmenü",
  LblCollapsedWebMenu: "Eingeklapptes Webmenü",
  LblMobileApp: "Mobiltelefon-App",
  LblSplashScreen: "Startbildschirm",
  LblWebApplication: "Webanwendungen",
  LblMobileApplication: "Anwendung Mobiltelefon-App",
  LblBrandingSavedSuccess: "Branding erfolgreich gespeichert",
  LblBrandingTemplateConfiguration: "Branding und Vorlagenkonfiguration",
  LblAppWebUI: "App und Web UI",

  LblNonBookingCommunication: "Allgemeine Kommunikation",
  LblBookingCommunication: "Kommunikation bezüglich Buchungen",
  LblInstanceBranding: "Stets Instanz-Branding nutzen",
  LblCompanyBranding: "Wenn möglich Unternehmensbranding benutzen",
  BO_TOP_MENU_ACTIVE_ITEM_BACKGROUND: "Obere Leiste, Menü und aktive Elemente",
  BO_TOP_MENU_ACTIVE_ITEM_TEXT: "Menütext",
  BO_HIGHLIGHTED_BUTTON_BACKGROUND: "Hervorgehobene Taste",
  BO_HIGHLIGHTED_BUTTON_TEXT: "Hervorgehobene Tastenbeschriftung",
  BO_HIGHLIGHTED_BUTTON_BACKGROUND_HOVER: "Hervorgehobene Taste(hover)",
  BO_HIGHLIGHTED_BUTTON_TEXT_HOVER: "Hervorgehobene Tastenbeschriftung (hover)",
  BO_PRIMARY_BUTTON_BACKGROUND: "Primäre Taste",
  BO_PRIMARY_BUTTON_TEXT: "Primäre Tastenbeschriftung",
  BO_PRIMARY_BUTTON_BACKGROUND_HOVER: "Primäre Taste (hover)",
  BO_PRIMARY_BUTTON_TEXT_HOVER: "Primäre Tastenbeschriftung (hover)",
  BO_SECONDARY_BUTTON_BACKGROUND: "Sekundäre Taste",
  BO_SECONDARY_BUTTON_TEXT: "Sekundäre Tastenbeschriftung",
  BO_SECONDARY_BUTTON_BACKGROUND_HOVER: "Sekundäre Taste (hover)",
  BO_SECONDARY_BUTTON_TEXT_HOVER: "Sekundäre Tastenbeschriftung (hover)",

  BO_HYPERLINK_TEXT: "Hyperlinktext",
  BO_HIGHLIGHT_BACKGROUND: "Farbe hervorheben",
  BO_HIGHLIGHT_TEXT: "Text hervorheben",
  BO_CALENDAR_EVENT_BACKGROUND: "Kalenderereignis",
  BO_CALENDAR_EVENT_TEXT: "Text Kalenderereignis",
  MO_TOP_MENU_ACTIVE_ITEM_BACKGROUND: "Kopfleiste und Menü",
  MO_LOGO_AREA_BACKGROUND: "Hintergrund Logofläche",
  MO_PAGE_BACKGROUND: "Hintergrund",
  MO_MENU_TEXT: "Menütext",

  MO_HYPERLINK_TEXT: "Hyperlinktext",
  MO_ENABLED_BUTTON_BACKGROUND: "Aktivierte Taste",
  MO_ENABLED_BUTTON_TEXT: "Text aktivierte Taste",
  MO_ENABLED_BUTTON_BACKGROUND_ACTIVE: "Aktivierte Taste (aktiv)",
  MO_ENABLED_BUTTON_TEXT_ACTIVE: "Text aktivierte Taste (aktiv)",
  MO_DISABLED_BUTTON_BACKGROUND: "Deaktivierte Taste",
  MO_DISABLED_BUTTON_TEXT: "Text gesperrte Taste",
  MO_DISABLED_BUTTON_BACKGROUND_ACTIVE: "Deaktivierte Taste (aktiv)",
  MO_DISABLED_BUTTON_TEXT_ACTIVE: "Text gesperrte Taste (aktiv)",
  MO_HIGHLIGHT_BACKGROUND: "Farbe hervorheben",
  MO_HIGHLIGHT_TEXT: "Text hervorheben",
  MO_CALENDAR_EVENT_BACKGROUND: "Kalenderereignis",
  MO_CALENDAR_EVENT_TEXT: "Text Kalenderereignis",
  MO_TITLE_TEXT: "Titeltext",

  LblBookingDelayConfig: "Einstellungen für Buchungsverzögerung",
  LblBookingDelayConfigEnabled: "E-Mail an Admin senden",
  LblEnableSnauilTrail: "Snail-Trail aktivieren",

  LblAppSupportTo: "App-Support für",
  LblNotificationInterval: "Benachrichtigungsintervall",
  LblNotifyAfterMinutes: 'Benachrichtigung nach «X» Minuten',
  LblMinutesAfterBookingEndTime: "Wie viele Minuten nach geplantem Buchungsende?",
  LblResendNotoficationEvery: "Benachrichtigung jede Minute erneut senden",
  LblMinutes: "Minuten",
  lblNotificationRecipients: "Benachrichtigungsempfänger",
  LbLEnableBookingStillRunning:
    "Benachrichtigung «Buchung nicht abgeschlossen» aktivieren",
  LblBookingrunningNotification:
    "Benachrichtigungseinstellungen «Buchung noch nicht abgeschlossen»",

  LblPreferableImageSize: "Bevorzugte Bildgrösse",
  LblWebBrandingExapandImageSize: "1150 px × 260 px",
  LblMobileBrandingImageSize: "550 px × 250 px",
  LblWebBrandingCollapseImageSize: "325 px × 250 px",

  //Raise and clear settings for low battery flag
  LblDefaultVehicleSetting: "Standard-Fahrzeugeinstellungen",
  LblLowBatteryFlagRaised: "Warnung für niedrigen Batteriestand erhöht bei (Spannung)",
  LblLowBatteryFlagClear:
    "Warnung für niedrigen Batteriestand aufgehoben bei (Spannung)",
  LblByBooking: "Nach Buchung",
  LblSnailTrailReport: "Snail-Trail-Bericht",
  LblKickbackReport: "Rückerstattungsbericht",
  LblGroupBy: "Gruppieren nach",
  LblTripDetail: "Fahrtdetails",
  LblTripNumber: "Fahrtnr.",
  LblStart: "Start ",
  LblAverageSpeed: "Durchschnittsgeschwindigkeit",
  LblSegmentDetail: "Abschnittdetails",
  LblSegmentNumber: "Abschnittsnr.",
  LblSpeed: "Geschwindigkeit",
  LblOdometer: "Kilometerzähler",
  LblNext: "Weiter",
  LblSegmentDetailNotAvailable: "Abschnittdetails nicht verfügbar",
  LblUnitPerKm: "pro km",
  LblUnitPerBooking: "pro Reservation",
  LblBookingCostSummary: "Übersicht Buchungskosten",
  LblTimeCost: "Zeitkosten",
  LblTotalTime: "Gesamtzeit",
  LblTime: "Zeit",
  LblCostRateUnits: "Kosten (Anzahl * Rate)",
  LblFreeTime: "Freie Zeit",
  LblRate: "Tarif",
  LblExVat: "Exkl. MWST",
  LblInclVat: "Inkl. MWST",
  LblKmDriven: "Gefahrene km",
  LblFreeKms: "Freicredits",
  LblTimePercent: "Zeitprozentsatz",
  LblTotalExVat: "Total exkl. MWST",
  LblTotalVat: "MWST insgesamt",
  LblTotalInclVat: "Total inkl. MWST",
  LblKilometerCost: "Kilometerkosten",
  LblFixedCost: "Fixkosten",
  LblTotals: "Gesamtsummen",
  LblTypeDamage: "Schaden",
  LblTypeMaintenance: "Periodische Wartung fällig",

  LblTypeOnSamePosition: "Fahrzeug am selben Standort seit mehr als %0 %1",
  LblTypeNotBooked: "Fahrzeug in nicht mehr als %0 %1 gebucht",
  LblTypeNotReturn:
    "Buchungszeit abgelaufen, Fahrzeug nicht am Heimatstandort",

  LblBatteryVoltage: "Batteriespannung",
  LblCannotUnsubscribe:
    "Abmelden jetzt nicht möglich, weil der Benutzer eine laufende Buchung hat",
  LblPer: "Pro",

  LblDateRegistered: "Registrierungsdatum",
  LblRegisteredBy: "Registriert durch",
  LblKMPerHour: "Km/h",
  LblMeters: "Meter",

  LblSubscriptionEndOnBookingEnd:
    "Buchung wird noch für dieses Abonnement ausgeführt. Der Fahrer wird abgemeldet, nachdem die Buchung abgeschlossen ist.",
  LblMarkedForDeletion: "Zwecks Löschung markiert",
  LblApplyDateFilter: "Datum Anwendbarkeit",

  LblNoRestriction: "Keine_Beschränkung",
  LblCustomAppTestApp: "CUSTOM_APP_UND_TEST_APP",
  LblCustomAppOnly: "NUR_CUSTOM_APP",
  LblPrePostTripQuestions: "Fragen für vor und nach der Fahrt",
  //Customer
  LblCustomer: "Anbieter",
  LblCustomerName: "Kundenname",

  //Role Page
  LblRoleManagement: "Rolle",
  LblRoleName: "Rollenname",
  LblEntityName: "Name Einheit",
  LblRoleType: "Rollentyp",
  LblRoleAvailability: "Verfügbarkeit Kundenrollen",
  LblInternalRoleName: "Interner Rollenname",
  LblPresentationName: "Präsentationsname",
  LblDefaultRole: "Standardrolle",
  LblCustomRole: "Benutzerdefinierte Rolle",
  LblAddRole: "Rolle hinzufügen",
  LblEntity: "Einheit",
  LblCopy: "Kopieren",
  LblAccessibilityMatrix: "Zugangsmatrix",
  LblDefaultRoleModifyWarning:
    "Das Anpassen von Standardrechten wirkt sich auf alle Benutzer mit Standardrolle aus",
  LblCopyAccessibilityMatrix: "Zugangsmatrix kopieren",
  LblAccess: "Zugang ",
  LblCustomerAdmin: "Kundenadmin",
  LblAdmin: "Admin",
  LblDoYouWantToRemove: "Möchten Sie %0 als %1 entfernen?",
  LblDoYouWantToAdd: "Möchten Sie %0 als %1 hinzufügen?",
  LblRoleAddedSuccess: "%0 %1 erfolgreich hinzugefügt.",
  LblRoleDeletedSuccess: "%0 erfolgreich aus %1 entfernt.",
  LblInstanceAdmin: "Instanzadmin",
  LblInvitationMailSuccess:
    "Einladungs-E-Mail wurde an die gegebene E-Mail-Adresse gesendet.",
  LblInvite: "Einladung versenden",
  LblCreateNew: "Neu erstellen",
  LblCommonErrorMessage:
    "Beim Verarbeiten der Anfrage ist ein Serverfehler aufgetreten. Bitte wenden Sie sich an den Administrator.",
  LblError: "Fehler",
  LblThankYouForAcceptingInvitation:
    "Vielen Dank, dass Sie die Einladung angenommen haben.",
  LblPleaseClick: "Bitte klicken Sie auf",
  LblHere: "hier",
  LblToLogin: "Zur Anmeldung",
  LblThankYouForConfirmation: "Vielen Dank für Ihre Bestätigung.",
  LblGoToHome: "Zurück auf Startseite",
  LblInvitationSuccess: "Einladung erfolgreich",
  LblInvitationReject: "Einladung abgelehnt",
  LblVehFutureBookingList: "Fahrzeugliste für künftige Buchungen",

  //
  LblAssignExisting: "Bestehende zuweisen",
  LblPersonProfileSuccessMessage: "Ihr Profil wurde erfolgreich aktiviert",
  LblPlease: "Bitte",
  LblLogin: "Anmeldung",

  //Organization
  LblVatNumber: "MWST-Nummer",

  //Branding & Template
  LblBrandingandTemplates: "Branding und Vorlagen",
  LblTermsAndCondition: "Allgemeine Geschäftsbedingungen",
  LblTermsAndConditionList:
    "AGB und Liste Datenschutzerklärung",
  LblVersion: "Version",
  LblAcceptance1: "Vor der Kontoaktivierung",
  LblAcceptanceMoment: "Genehmigungszeitpunkt",
  LblContents: "Inhaltsverzeichnis",
  LblIsAccept: "Ich stimme zu",
  LblReadAndAgree: "Ich habe [...] gelesen und erkläre mich damit einverstanden",
  LblClose: "Schliessen",
  LblTermsConditionPrivacy: "AGB und Datenschutzerklärung",
  LblPrivacyStatements: "Datenschutzerklärung",

  //Pre Post Trip Setting
  LblPrePostTripSetting: "Einstellungen Fragen für vor und nach der Fahrt",
  LblPrePostTripQuestion: "Frage für vor und nach der Fahrt",
  LblPrePostTripQuestionList: "Frageliste für vor und nach der Fahrt",
  LblPreTripQuestion: "Fragen für vor der Fahrt",
  LblCustom: "Kundenspezifisch",
  LblPostTripQuestion: "Fragen für nach der Fahrt",
  LblRequired: "Erforderlich",
  LblBeforeOpeningTheVehicle: "Vor Öffnen des Fahrzeugs",
  LblAfterOpeningTheVehicle: "Nach Öffnen des Fahrzeugs",
  LblOrder: "Sortieren",
  LblQuestion: "Frage",
  LblOn: "Auf",
  LblOptional: "Optional",
  LblOff: "Aus",
  LblAnswerType: "Antworttyp",
  LblText: "Text",
  LblYesNo: "Ja/Nein",
  LblAnswer: "Antwort",
  LblTimeStamp: "Zeitstempel",
  LblFazTripQuestion: "FaZ fragen",
  LblFazTripQuestionAfterClosingTheVehicle: "FaZ fragen nach Schließen des Fahrzeugs",

  //Instance Clone
  'LblInstanceClone': 'Instanz kopieren',
  'LblNewInstanceName': 'Neuer Instanzname',
  'LblCloneResult': 'Ergebnis kopieren',
  'LblCloneStatus': 'Status kopieren',
  'CloneError': 'Beim Kopieren der Instanz und der entsprechenden Einheiten ist ein Fehler aufgetreten.',


  //Accessibility Matrix
  LG_WEB_DASHBOARD: "Web-Dashboard",
  PR_BOOKING_REQUEST: "Buchungsanfrage",
  PR_PRE_POST_TRIP_QUESTIONS: "Fragenübersicht für vor und nach der Fahrt",
  LblApproveBookingRequest: "Genehmigen",
  LblRejectBookingRequest: "Ablehnen",

  PR_DASHBOARD: "Dashboard",

  PR_REMOVE_DRIVER_LICENSE: "Remove Driver License",


  PR_VEHICLE_FUTURE_BOOKINGS: "Künftige Fahrzeugbuchungen",

  PR_INSTANCE: "Instanz",
  PR_BRANDING: "Branding",
  PR_PERSON_OVERVIEW: "Personenübersicht",
  PR_WEGO_ADMINS: "WeGo-Admins",
  PR_COMPANY_OVERVIEW: "Unternehmensübersicht",
  PR_CONTACT_PERSON: "Ansprechpartner",
  PR_COMPANY_ADMIN: "Unternehmensadmin",
  PR_COMPANY_VEHICLE_OVERVIEW: "Übersicht Unternehmensfahrzeuge",
  PR_COMPANY_SVG_OVERVIEW: "Übersicht Carsharing-Gruppen Unternehmen",
  PR_ORGANIZATION_OVERVIEW: "Organisationsübersicht",
  PR_ORGANIZATION_CONTACT_PERSON: "Ansprechpartner Organisation",
  PR_ORGANIZATION_ADMIN_OVERVIEW: "Übersicht Organisationsadmin",
  PR_ORGANIZATION_DRIVER_OVERVIEW: "Fahrerübersicht Organisation",
  PR_SHARED_VEHICLE_GROUP_OVERVIEW: "Übersicht Carsharing-Gruppe",
  PR_SHARED_VEHICLE_GROUP_ADMIN_OVERVIEW: "Adminübersicht Carsharing-Gruppe",
  PR_SHARED_VEHICLE_GROUP_VEHICLE_OVERVIEW: "Fahrzeugübersicht Carsharing-Gruppe",
  PR_SHARED_VEHICLE_GROUP_DRIVER_OVERVIEW: "Fahrerübersicht Carsharing-Gruppe",
  PR_SHARED_VEHICLE_GROUP_CONTRACT_TYPE_GROUP_OVERVIEW:
    "Übersicht Vertragstypengruppe Carsharing-Gruppe",
  PR_SHARED_VEHICLE_GROUP_CONTRACT_TYPE_OVERVIEW:
    "Übersicht Vertragstypen Carsharing-Gruppe",
  PR_SHARED_VEHICLE_GROUP_SUBSCRIPTION_OVERVIEW:
    "Abonnementübersicht Carsharing-Gruppe",
  PR_SHARED_VEHICLE_GROUP_SUBSCRIPTION_AVAILIBILTY_RESTRICTION_OVERVIEW:
    "Übersicht Verfügbarkeitsbeschränkung Abonnement Carsharing-Gruppe",
  PR_SPECIAL_PERIODS: "Sonderperioden",
  PR_VEHICLES_OVERVIEW: "Fahrzeugübersicht",
  PR_VEHICLE_SVG_OVERVIEW: "Übersicht Carsharing-Gruppen",
  PR_VTS_VEHICLE_LIST: "VTS-Fahrzeugliste",
  PR_VTS_TROUBLESHOOT: "VTS-Fehlerbehebung",
  PR_VEHICLE_ATTRIBUTE_CATEGORIES: "Fahrzeugattributkategorien",
  PR_VEHICLE_ATTRIBUTE: "Fahrzeugattribut",
  PR_ODOMETER_LOG_TRAIL: "Historie Kilometerzähler",
  PR_ODOMETER_LOG_TRAIL_REGISTERED_BY:
    "Historie Kilometerzähler registriert von",
  PR_DRIVER_OVERVIEW: "Fahrerübersicht",
  PR_DRIVER_SHARED_VEHICLE_GROUP_OVERVIEW: "Fahrerübersicht Carsharing-Gruppe",
  PR_DRIVER_SHARED_VEHICLE_GROUP_SUBSCRIPTION_OVERVIEW:
    "Abonnementübersicht Fahrer Carsharing-Gruppe",
  PR_BOOKINGS_OVERVIEW: "Buchungsübersicht",
  PR_NORMAL_BOOKING: "Neue Buchung",
  PR_SPECIAL_BOOKING: "Sonderbuchung",
  PR_TRIP_SIMULATOR: "Fahrtsimulator",
  PR_INVOICE: "Rechnung",
  PR_DIRECT_DEBIT_FILE: "Lastschriftdatei",
  PR_ADDITIONAL_FREE_ITEMS: "Zusätzliche Gratiselemente",
  PR_TEST_INVOICE_GENERATOR: "Generator Testrechnung",
  PR_VEHICLE_OCCUPANCY_REPORT: "Fahrzeugbelegungsbericht",
  PR_REVENUE_PER_VEHICLE_REPORT: "Bericht Erlös pro Fahrzeug",
  PR_TRIP_DATA_REPORT: "Fahrtdatenbericht",
  PR_MAINTENANCE_PLANNING_REPORT: "Bericht Wartungsplanung",
  PR_SANIL_TRAIL_REPORT: "Snail-Trail-Bericht",
  PR_KICKBACK_REPORT: "Rückerstattungsbericht",
  PR_INVOICE_PAYMENT_HISTORY: "Verlauf Rechnungszahlung",
  PR_TEMPLATES: "Vorlagen",
  PR_SIGNUP_FORMS_OVERVIEW: "Übersicht Registrierungsformulare",
  PR_SIGNUPS_OVERVIEW: "Registrierungsübersicht",
  PR_SIGNUP_OVERVIEW_TO_SIGNUP_FORM:
    "Registrierungsübersicht an Registrierungsformular",
  PR_SIGNUP_OVERVIEW_TO_SHARED_VEHICLE_GROUP:
    "Registrierungsübersicht an Carsharing-Gruppe",
  PR_TERMS_AND_CONDITION: "Allgemeine Geschäftsbedingungen",
  PR_EVENT_VIEWER: "Ereignisviewer",
  PR_PRE_POST_TRIP_SETTING: "Einstellungen Fragen für vor und nach der Fahrt",
  PR_PREPOST_TRIP_QUESTIONS_UPDATE: "Fragen für vor und nach der Fahrt",
  PR_USER_PROFILE: "Nutzerprofil",
  LG_CUSTOMER: "Kunde",
  LG_INSTANCE: "Instanz",
  LG_BRANDING: "Branding",
  LG_PERSON: "Person",
  LG_COMPANY: "Unternehmen",
  LG_ORGANIZATION: "Organisation",
  LG_SHARED_VEHICLE_GROUP: "Carsharing-Gruppe",
  LG_VEHICLE: "Fahrzeug",
  LG_DRIVER: "Fahrer",
  LG_BOOKING: "Buchung",
  LG_INVOICE: "Rechnung",
  LG_REPORT: "Bericht",
  LG_TEMPLATE: "Vorlage",
  LG_SIGNUP_FORM: "Registrierungsformular",
  LG_EVENT_VIEWER: "Ereignisviewer",
  LG_PRE_POST_TRIP_SETTING: "Einstellungen Fragen für vor und nach der Fahrt",
  LG_USER: "Nutzer",
  LG_BRANDING_AND_TEMPLATE: "Branding und Vorlagen",

  LG_ROLE: "Rolle",
  LG_PREPOSTTRIPQUESTION: "Fragen für vor und nach der Fahrt",
  PR_CUSTOMER_ADMIN_OVERVIEW: "Übersicht Kundenadmin",
  PR_INSTANCE_ADMIN_OVERVIEW: "Übersicht Instanzadmin",
  PR_ROLE_OVERVIEW: "Rolle",
  PR_ROLE_ASSIGN: "Rollenzuweisung",
  PR_SHARED_VEHICLE_GROUP_ACTIVE_INACTIVE: "Carsharing-Gruppe aktiv oder inaktiv",
  PR_CUSTOMER_OVERVIEW: "Kunde",
  PR_ORGANIZATION_SUBSCRIPTION_OVERVIEW: "Abonnementübersicht Organisation",
  PR_VTS_VEHICLE_EVENT_HISTORY: "VTS-Fahrzeugereignishistorie",
  PR_BATCH_UPLOAD_PERSON: "Personen gesammelt importieren",
  PR_IMPORT_PERSON: "Person importieren",
  PR_PRE_POST_TRIP_QUESTION_UPDATE: "Fragen für vor und nach der Fahrt",

  LG_REPORTINGTOOL: "Reporting-Tool",
  PR_BOOKING_OVERVIEW: "Buchungsübersicht",
  PR_ROBNOTIFICATIONS: "ROB-Übersicht",
  PR_MILEAGE_OVERVIEW: "Kilometerübersicht",
  PR_USAGE_OVERVIEW: "Anzahl der nicht genutzten Tage",
  PR_POSITION_ON_MAP: "Position auf der Karte",
  PR_VEHICLE_ON_LOCATION_MAP: "Fahrzeug vor Ort",
  PR_TRIP_OVERVIEW: "Reiseübersicht",
  PR_ALTERNATE_TRANSPORTATION: "Ersatzfahrzeuge",
  PR_AVERAGE_OVERVIEW: "Durchschnitte Übersicht",
  PR_PRE_POST_BOOKING_OVERVIEW: "Fragen vor/nach der Buchung übersicht",
  PR_HOME_LOCATIONS_OVERVIEW: "Übersicht über Fahrzeug- und SVG-Heimstandorte",


  LblPrivacyErrorMessage: "Sie sind nicht dazu berechtigt, diese Seite aufzurufen",
  LblPrivacyNavigate: "Bitte navigieren Sie zu",
  LblPrivacyError: "Datenschutzfehler",
  LblLinkExpired: "Link abgelaufen",
  LblLinkExpiredMessage:
    "Der Link ist abgelaufen und kann nicht mehr genutzt werden. Bitte versuchen Sie es erneut.",
  LblBearer: "Inhaber",
  LblWhoBenifitFreeItem: "Wer profitiert von Abonnementguthaben?",
  LblNoDistinction: "Standard (keine Unterscheidung)",
  LblSendInvoiceToOrganization: "Rechnung an Organisation senden",

  //Vat Setting
  LblVatSettings: "MWST-Einstellungen",
  LblVatPercentages: "MWST-Satz",
  LblDefaultCost: "Kosten automatisch anzeigen und bearbeiten",
  LblExcludingVat: "Exklusive MWST",
  LblIncludingVat: "Inklusive MWST",
  LblVatEnterDescription: "Beschreibung eingeben",
  LblEnterVatPercentage: "MWST in % eingeben",
  LblVatPercentageError: "Bitte geben Sie einen gültigen Prozentsatz ein",
  LblVatDescriptionError: "Bitte geben Sie eine gültige Beschreibung ein",
  LblVatStartDate: "Startdatum",
  LblVatStartDateError: "Bitte Startdatum wählen",
  LblVatEndDate: "Enddatum",
  LblVatDeleteConfirmation:
    "Möchten Sie dieses MWST-Enddatum wirklich festlegen?",
  LblVatEndDateError: "Bitte geben Sie das MWST-Enddatum ein",
  LblVatEndDateNote: "Hinweis: Daten werden ab dem gewählten Datum ausgeschlossen",
  LblDefaultVatContractTypeGroupCost: "MWST in % für Vertragstypen-Gruppenkosten",
  LblDefaultVatContractTypeCost: "MWST in % für Vertragstypkosten",
  LblDefaultVatSubscriptionCost: "MWST in % für Abonnementkosten",
  LblPenaltyCost: "Strafkosten",
  LblTimeRates: "Zeittarife",
  LblDistanceRates: "Distanztarife",
  LblFixedRates: "Feste Tarife",
  LblSubscriptionCost: "Abonnementkosten",

  LblPenaltyVat: "Strafe MWST",
  LblTimeRateVat: "Zeittarif MWST",
  LblMileageRateVat: "Kilometergeld MWST",
  LblFixedFeeVat: "Fixgebühr MWST",
  LblExpenseAmountVat: "Betrag Ausgaben MWST",

  // template
  LblEmailTemplate: "E-Mail-Vorlage",
  LblWebTemplate: "Webvorlage",
  LblEmailAddressesEntryPattern: "E-Mail-Adressen durch Komma getrennt (Beispiel: ex1@ex.com, ex2@ex.com)",
  LblNoRecipientWarning:
    "Keine Empfänger verfügbar. Standardempfänger sind Empfänger dieser Vorlage.",
  LblStartDate: "Startdatum",
  LblChamberOfCommerce: "Handelskammer",
  LblInvoicingSettings: "Einstellungen Rechnungsstellung",
  LblInvoiceSender: "Rechnungsabsender",

  LblCostAndExpenses: "Kosten und Ausgaben",
  LblSender: "Absender",
  LblAddressee: "Empfänger",
  LblAddLine: "Zeile hinzufügen",
  LblSaveInvoice: "Rechnung speichern",
  LblVatAmount: "Betrag MWST",
  LblBookingId: "Buchungs-ID",
  LblReceiptOrSuppor: "Beleg oder Support",
  LblVATPercentage: "MWST-Satz",
  LblChargeTo: "Aufladen bis",
  LblReimburseTo: "Rückerstattung an",
  LblReportedBy: "Gemeldet von",
  LblReportedAmount: "Gemeldeter Betrag",
  LblApprovedAmount: "Genehmigter Betrag",
  LblCostType: "Kostenart",
  LblRecipient: "Empfänger",
  LblName: "Name",
  LblCostDetail: "Kostendetails",

  LblAddExisting: "Vorhandene hinzufügen",
  LblReceiptOrSupport: "Beleg oder Support",
  LblManualInvoiceLine: "Manuelle Rechnungszeile",
  LblInvoiceLine: "Rechnungszeile",
  LblInvoice: "Rechnung",
  LblInvoiceLines: "Rechnungszeilen",
  LblSendInvoice: "Rechnung versenden",
  LblInvoiceSent: "Rechnung versendet",
  LblAddNewInvoiceLine: "Neue Rechnungszeile hinzufügen",
  LblSelectUnprocessedExpenses: "Wählen Sie unverarbeitete Ausgaben",
  LblSelectAtLeastOneExpense: "Bitte wählen Sie mindestens eine Ausgabe",
  LblInvoicePaymentHistory: "Verlauf Rechnungszahlung",
  LblPaymentMode: "Zahlungsart",
  LblLogTime: "Protokollierungszeit",
  LblNoPaymentLinkGenerated: "Kein Zahlungslink generiert",

  //Payment
  LblAllowPaymentConfiguration: "Zahlungskonfiguration zulassen",
  LblAllowPayment: "Zahlung zulassen",
  LblPaymentSetting: "Einstellungen Zahlungsanbieter",
  LblEnvironment: "Umgebung",
  LblInvoicePaymentTermDays: "Rechnungszahlungsbedingungen Tage",
  LblLinkValidityDays: "Linkgültigkeit in Tagen",
  LblPaymentMethods: "Zahlungsmethoden",
  LblPaymentConfig: "Zahlungskonfiguration",
  LblPaymentConfigButton: "Zahlungskonfiguration",
  LblPaymentProvider: "Zahlungsanbieter",
  LblCountry: "Land",
  LblEmailAddress: "E-Mail-Addresse",
  LblPaymentProviderSecretKey: "Geheimer Schlüssel des Anbieters",
  LblPaymentProviderUsername: "Benutzername Anbieter (key)",
  LblCreditCardPayment: "Kreditkartenzahlung",
  LblInitialPayment: "Anzahlung",
  LblCreateBookingPayment: "Buchungszahlung erstellen",
  LblStartBookingPayment: "Buchungszahlung starten",
  LblPaymentLink: "Zahlungslink",
  LblPaymentHistory: "Zahlungsverlauf",
  LblReasonOrganization: "Grund für die Blockierung der Organisation",
  LblDueDateUpdateSuccess: "Fälligkeitsdatum erfolgreich aktualisiert",
  LblDueDateRequiredError: "Bitte wählen Sie das Fälligkeitsdatum",
  LblDueDate: "Fälligkeitsdatum",
  LblConfirmDuedatechange:
    "Möchten Sie das Fälligkeitsdatum wirklich aktualisieren?",
  LblConfirmCloseInvoice: "Möchten Sie die Rechnung wirklich schliessen?",
  LblConfirmReOpenInvoice:
    "Möchten Sie die Rechnung wirklich erneut öffnen?",
  LblInvoiceOpenCloseSuccess: "Rechnung %0 erfolgreich",
  LblReOpen: "Erneut öffnen",
  LblClosed: "Geschlossen",
  LblReOpenClose: "Erneut öffnen/Schliessen",
  PR_COST_EXPENSES: "Kosten und Ausgaben",
  PR_COST_CENTER_REPORT: "Kostenstellenbericht",

  LblReportedOn: "Gemeldet am",
  LblInactiveAfterDays: "Inaktiv nach (Tagen)",
  LblMarkDeleteAfterDays: "Markierung löschen nach (Tagen)",
  LblNotifyAdminBeforeDays: "Admin vor Ablauf von (Tagen) benachrichtigen",
  LblGdprSettings: "DSGVO-Einstellungen",
  LblRemovalDate: "Entfernungsdatum",
  LblRemovePersonOn: "Person entfernen am",
  PR_PAYMENT_HISTORY_LIST: "Zahlungsverlauf",
  LblUserBlockMessage: "Nachricht bei Benutzerblockung",
  PR_BLOCK_UNBLOCK_ORGANIZATION: "Organisation blocken/entsperren",
  LblWhenOpeningAppAndRepeat: "Beim ersten Öffnen der App und anschliessend alle",
  LblEveryTimeOpenApp: "Jedes Mal, wenn die App geöffnet wird",
  LblWhenMakeBooking: "Beim Erstellen einer Buchung",
  LblWhenStartBooking: "Beim Start einer Buchung",
  LblWhenOpenBooking: "Beim Öffnen eines Fahrzeugs",
  LblSelectContractTypeGroup: "Bei der Auswahl einer bestimmten Vertragsartgruppe/bestimmter Vertragsartgruppen",
  LblDays: "Tage",
  LblNewVersion: "Neue Version",
  LblAction: "Aktion",
  LblTAndCName: "AGB-Name",
  LblOldVersion: "Alte Version",
  LblSureToRevoke: "Möchten Sie %0 wirklich widerrufen?",
  LblCurrencyConfiguration: "Währungskonfiguration",
  LblNameSingular: "Name Singular",
  LblNamePlural: "Name Plural",

  //Special Period
  LblRegularBooking: "Regelmässige Buchung",
  LblSpecialRate: "Sondertarif",
  LblFirstDay: "Erster Tag",
  LblLastDay: "Letzter Tag",
  LblWeekEndContaining: "Wochenende mit",
  //Credit card payment

  LblCrediCardPayment: "Kreditkartenzahlung",
  LblFirstBooking: "Erstbuchung",
  LblAllowRecurringPayment: "Kreditkarte autorisieren",
  LblProceed: "Fortsetzen",
  LblCheckAllowPayment: "Bitte wiederkehrende Zahlung prüfen",
  LblPaymentFailed: "Kreditkarte autorisieren",
  LblPaymentSuccess: "Autorisierung erfolgreich",
  LblPaymentFailure: "Autorisierung fehlgeschlagen",
  LblCompletedSuccess: "Ihre Autorisierung wurde erfolgreich bearbeitet",

  LblCompletedFailure:
    "Ihre Autorisierung ist fehlgeschlagen. Bitte gehen Sie zurück und versuchen Sie es erneut.",
  LblCreditCardNumber: "Kreditkartennummer",
  LblCreditCardExpirationDate: "Verfalldatum Kreditkarte",
  LblCreditCardDetails: "Kreditkartendetails",

  LblMakePayment: "Kreditkarte autorisieren",

  LblAdminPaymentConfirmation:

    "Es liegt keine aktive Autorisierung vor oder die Zahlung ist fehlgeschlagen. Möchten Sie fortfahren?",

  LblPaymentDescription:
    "Um ein Fahrzeug zu buchen, ist eine Verifizierungszahlung von %0 erforderlich. Darüber hinaus ist die Genehmigung erforderlich, zukünftige Zahlungen von Ihrer Kreditkarte abzuziehen. Zahlungen werden von unserem Zahlungsanbieter Buckaroo bearbeitet. Sie werden für die Zahlung auf die Website von Buckaroo weitergeleitet.",
  LblPay: "Bezahlen",

  LblWeGoDefault: "WeGo Standard",
  LblPersonActiveSuccess: "Person erfolgreich aktiviert",
  LblActivate: 'Aktivieren',


  LblSignBeforeAmount: "Währungssymbol vor Betrag",
  LblOutOf: 'Aus',
  LblByOrganization: "Nach Organisation",
  // NIF Number
  LblEnableNIFNumber: "NIF-Nummer aktivieren",
  LblNIFNumber: "NIF-Nummer",
  LblDefaultLanguage: 'Standardsprache',
  LblRestoreInheritConfirmation: "Die aktuellen Einstellungen werden von den geerbten Einstellungen überschrieben. Möchten Sie wirklich?",
  LblQestionTextRequired: "Fragentext erforderlich",
  LblManualSecretKey: "Geheimer Schlüssel",
  // Two Factor Authentication
  LblTwoFaConfig: "Zwei-Faktor-Authentifizierung",
  LblEnableTwoFa: "Aktivieren Sie die Zwei-Faktor-Authentifizierung",
  LblExpirationDays: "Verfallstage",
  LblTextBoxExpirationDays: "Verfallstage",
  Lbl2FactorAuthenticateExpDays: "2FA Verfallszeit (Tage):",
  LblResetCookiesWegoAdmin: "Setzen Sie die Cookies für alle WeGo-Admin zurück",
  LblReset2FactorAuthWegoAdmin: "Setzen Sie alle 2FA für alle WeGo-Admin zurück",
  LblAuthentication: "Authentifizierung",
  LblResetCookiesForAllAdmin: "Setzen Sie die Cookies für alle Admin zurück",
  LblReset2FaForAllAdmin: "Setzen Sie 2FA für alle Admin zurück",
  LblEnterTotp: "Bitte geben Sie den Code ein",
  LblEnterOtp: "Bitte geben Sie den Code ein",
  LblSubmit: "Einreichen",
  LblKeyResetSuccess: "2FA-Schlüssel wurde zurückgesetzt",
  LblKeyResetFailed: "2FA-Schlüsselrücksetzung fehlgeschlagen",
  LblCookieResetSuccess: "2FA-Cookies wurden zurückgesetzt",
  LblCookieResetFailed: "Das Zurücksetzen der 2FA-Cookies ist fehlgeschlagen",
  LblGoogleAuthenticator: "Google Authenticator App",
  LblEmailOtpSent: "Ein Code wurde an Ihre registrierte E-Mail-Adresse gesendet",
  LblContinue: "Fortsetzen",
  LblInvalidTOTP: "Ungültiger Code",
  LblResetCookie: "Cookie zurücksetzen",
  LblResetTwoFA: "2FA zurücksetzen",
  LblDisableTwoFA: "Deaktivieren Sie 2FA",
  LblTwoFaMethod: "2FA-Methode",
  LblEmailAuthentication: "E-Mail-Authentifikation",
  LblTwoFaMethodSelect:"Sie müssen Ihre Identität noch einmal überprüfen. Bitte wählen Sie Ihre 2FA-Methode",
  LblInvoicePreFix: "Präfix der Rechnungsnummer",
  LblEngineStillRunning:'Verriegelungsbefehl wurde gesendet, während der Motor lief',
  LblMobileAppLink: "Mobile App Link",

  // License Check Configuration
  LblLicenseCheckConfiguration: "Konfiguration der Lizenzprüfung",
  LblValidateLicenseCheckForBooking: "Überprüfen vor Buchung",

  // Access Cards Enabled SVG
  LblAccessCardsEnabled: "Zugangskarte nutzung",

  // Track & Trace
  LblTrackAndTrace: "Track & Trace",
  LblRfidTagId: "RFID Tag ID",
  LblEmployeeNumber: "Mitarbeiternummer",
  BtnAddVehicleInfo: "Mit Vts Log",

  // Access Card
  LblAccessCardId: "Access Card ID",

  LblDriversLicenseAndCertificates: "Führerschein und Zertifikate",
  LblLicense: "Führerschein",
  LblCertificates: "Zertifikate",

  LblTrips: "Fahrten",
  LblCostsSummary: "Buchungskosten",
  LblStartBooking: "Buchung starten",
  LblStopBooking: "Buchung abbrechen",

  LblTripHistory: "Fahrgeschichte",
  LblTripStartDateTime : "Ab",
  LblTripEndDateTime: "Bis",
  LblFaZTripQuestions: "FaZ-Fragen",
  LblNoQuestionsFound: "Keine FaZ-Fragen gefunden.",
  LblTripDetails: "Fahrt details",
  LblNoTripsFound: "Keine Fahrten gefunden",
  LblUnansweredQuestions: "Unbeantwortete Fragen",
  LblNoUnansweredQuestions: "Keine unbeantwortete Fragen",
  LblAnswerSaved: "Die Antwort wurde erfolgreich gespeichert",
  LblAnswerSavedError: "Die Antwort konnte nicht gespeichert werden. Bitte wenden Sie sich an den Administrator",
  LblAnswerEmptyError: "Bitte geben Sie eine gültige Antwort ein",

  LblLoginError: "Beim Einloggen ist ein unbekannter Fehler aufgetreten",
  LblLoginCredentialsError: "Dieser Benutzername oder dieses Passwort ist falsch, bitte überprüfen Sie es und versuchen Sie es erneut",
  ValidatePhoneNumberVts: "Bitte geben Sie eine gültige Telefonnummer ein (zum Beispiel +31623456789)",
  LblInfo: "Info",
};



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/shared/translate/lang-de.ts